<style scoped>
.handle {
  float: left;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 8px;
}
.close {
  float: right;
  padding-top: 8px;
  padding-bottom: 8px;
}

.draginput {
  display: inline-block;
  width: 95%;
}
.multiselect--active{
  z-index: 99;
}
</style>

<script>
import Alert from '@/components/Alert';
import Pagination from '@/components/Pagination';
import ErrorComponent from '@/components/ErrorComponent';
import draggable from 'vuedraggable';
import moment from 'moment';
import EventBus from '../../eventBus';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import accessible from '@/mixins/accessible'
import OnlineStorefront from './OnlineStorefront'
import SobatCategory from './SobatCategory'
import Multiselect from "vue-multiselect";

export default {
  name: 'Settings',
  components: {
    Pagination,
    Alert,
    ErrorComponent,
    draggable,
    DatePicker,
    OnlineStorefront,
    SobatCategory,
    Multiselect
  },
  data() {
    return {
      isAll: false,
      availableStoreStr: "",
      storeListOrigin: [],
      storeList: [],
      selectedStores: [],
      is_owner: false,
      user: {
      },
      actualSetting: {
        kitchen_printers: false,
        dining_options: false,
        open_tickets: false
      },
      setting: {
        shifts: false,
        time_clock: false,
        open_tickets: false,
        kitchen_printers: false,
        customer_display: false,
        dining_options: false,
        user_define_tickets: false,
        low_stock: false,
        is_enable_b2b: true,
        negative_stock_alerts: false,
        is_denotations: false,
        menu_app: false,
        is_menu_app: false,
        customer_sharing: false,
        storefront: false,
        ui_language: '',
        email: '',
        business_name: '',
        timezone: '',
        force_disable_storefront: false,
        force_disable_dining_options: false,
      },
      store_id: '',
      languages: [],
      payment_type: {
        name: '',
        payment_type: '',
        stores: []
      },
      e_wallet_payment_name_list: [],
      e_wallet_payment: {name:'', phone_number: ''},
      e_wallet_other_payment_name: '',
      stores: [],
      pos_list: [],
      menu_list: [],
      all_stores: [],
      pos_obj: {},
      menu_obj: {},
      tax_list: [],
      subscription_list: [],
      tax_store_id: '',
      receipt_store_id: '',
      receipt: {
        receipt_language: '',
        show_customer_info: false,
        show_comments: false
      },
      access_right: {},
      file: null,
      payment_type_obj: {},
      tax_obj: {},
      paymentTypeOperation: this.$lang.messages.add,
      checkedPaymentTypes: [],
      printers: [],
      checkedPrinters: [],
      dinningOptions: [],
      dinning_option_store_id: '',
      payments: [],
      payment_store_id: '',
      open_tickets_store_id: '',
      open_ticket: {
        use_predefined_tickets: false
      },
      checkedTaxes: [],
      store: {},
      owner_id: null,
      timezones: [],
      countryList: [],
      stateList: [],
      districtList: [],
      cityList: [],
      personstateList: [],
      persondistrictList: [],
      personcityList: [],
      villageList: [],
      languageList: [],
      subbusinessList: [],
      businessList: [],
      bankList: [],
      client: {
        id: '',
        business_info: {
          id: '',
          business_type_id: '',
          sub_business_type_id: '',
          state_id: '',
          district_id: '',
          city_id: '',
          business_entity_type: 'PERSONAL',
          business_name: '',
          email: '',
          phone_number: '',
          mobile_number: '',
          postal_code: '',
          address: '',
          is_verified: '',
          timezone: ''
        },
        person_info: {
          id: '',
          id_card_number: '',
          id_card_name: '',
          email: '',
          phone_number: '',
          gender: '',
          date_of_birth: '',
          state_id: '',
          district_id: '',
          city_id: '',
          village_id: '',
          home_address: '',
          RT: '',
          RW: ''
        },
        bank_info: {
          account_number: '',
          name: '',
          bank_id: ''
        },
        subscription_id: '',
        setting_pin: '',
      },
      jubelio: {
        id: '',
        email: '',
        password: '',
        is_enable: true,
        status: '',
        company_name: '',
        default_salesmen_id: '',
        default_po_salesmen_id: '',
        default_location_id: 0,
      },
      jubelioContacts: [],
      jubelioLocations: [],
      jubelioItemsData:{
        objects:[],
        pages: 0,
        pageSize: 0
      },
      currentPage: 1,
      itemsPerPage: 10,
      query: '',
      jubelio_item_type: 'ITEM',
      country_code: '',
      settingSobatCategory: false,
      settingOnlineStorefront: false,
      settingOnlineStorefrontNeedConfirm: false,
      dinningOptionId: 0,
      paymentId: 0,
      employeeChangePassword: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      deletedPaymentId: null,
      deletedPaymentStoreId: '',
      uncheckPaymentId: null,
      uncheckPaymentStoreId: '',

    };
  },

  mixins: [accessible],

  computed: {
    mobileSetting() {
      const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPod/i, /BlackBerry/i, /Windows Phone/i]
      const mobileDevice =  toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem)
      })

      return this.$route &&
        this.$route.query &&
        !!this.$route.query.store_id &&
        mobileDevice
    },
    d2c_type(){
      return parseInt(localStorage.getItem('d2c_type') || 0)
    }
  },

  methods: {
    check() {},
    checkMenuApp() {},
    getMe() {
      this.$api
        .getAPI({
          _action: `/me?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}`
        })
        .then(async res => {
          this.owner_id = res.owner_id;
          if (res.user.is_owner) {
            this.is_owner = true;
          }
          if (res.days) {
            localStorage.setItem('days', res.days);
          }
          this.access_right = res.access_right;
          if (!this.access_right.edit_profile) {
            this.selectMainTab('RECEIPT');
          }

          if (!res.user.is_owner && !res.user.is_change_password) {
            this.showChangePasswordAlert()
          }

          await this.getDetail();
        });
    },

    showChangePasswordAlert() {
      this.$refs.ChangePasswordLink.click();
    },

    logoutJubelio() {
      var bodydata = this.jubelio
      bodydata['status'] = 'INACTIVE'
      bodydata['is_enable'] = false
      this.$api
        .postAPI({
          _action: '/integration/jubelio/update',
          _body: bodydata,
        })
        .then(res => {
          this.getJubelioInfo()
        })
        .catch(e => {
          console.log(e.message);
        });
    },

    jubelioSyncItem(item){
      this.$api
        .postAPI({
          _action: '/integration/jubelio/inventory/items/sync',
          _body: item,
        })
        .then(res => {
          this.jubelioInventoryItem(this.currentPage)
          if(!!res.message) {
            this.$notify({
              group: 'foo',
              text: res.message,
              type: 'success '
            });
          }
        })
        .catch(e => {
          console.log(e.message);
        });
    },
    setJubelioItemType(type){
      this.jubelio_item_type = type
      this.jubelioInventoryItem(1)
    },

    pageChange(page) {
      this.jubelioInventoryItem(page)
    },
    itemsPerPageChange() {
      console.log('itemsPerPageChange', this.$refs.listPagination.itemsPerPage)
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.jubelioInventoryItem(1);
    },

    showDeleteTaxAlert() {
      this.$refs.deleteMultipleTaxesLink.click();
      this.$refs.deleteMultipleTaxesAlert.message = this.$lang.messages.delete_multiple_taxes_message;
    },

    checkAllKitchenPrinter() {
      this.checkedPrinters = [];
      if (event.target.checked) {
        for (var i = 0; i < this.printers.length; i++) {
          this.checkedPrinters.push(this.printers[i].id);
        }
      }
    },
    showDeleteKitchenPrinterAlert() {
      this.$refs.deleteMulitpleKitchenPrinterLink.click();
      this.$refs.deleteMultipleKitchenPrinterAlert.message = this.$lang.messages.delete_kitchen_printers_message;
    },
    unselectAllKitchenPrinter() {
      this.checkedPrinters = [];
      if (this.$refs.del_kp) {
        this.$refs.del_kp.checked = false;
      }
    },
    checkUncheckKitchenPrinter() {
      if (this.$refs.del_kp) {
        if (
          this.checkedPrinters.length > 0 &&
          this.checkedPrinters.length == this.printers.length
        ) {
          this.$refs.del_kp.checked = true;
        } else {
          this.$refs.del_kp.checked = false;
        }
      }
    },

    deleteKitchenPrinter(isMultiple) {
      var body = {
        list: this.checkedPrinters
      };
      this.$api
        .postAPI({
          _action: '/backoffice-setting/delete_multiple',
          _body: body
        })
        .then(res => {
          this.getKitchenPrinters();
          this.$notify({
            group: 'foo',
            text: this.$lang.messages.deleted_successfully,
            type: 'success'
          });
          this.checkedPrinters = [];

          if (isMultiple) {
            this.$refs.deleteMultipleKitchenPrinterAlert.close();
          } else {
            this.$refs.deleteKitchenPrinterAlert.close();
          }
        })
        .catch(e => {
          this.getKitchenPrinters();
        });
    },

    getEwalletPaymentName() {
      this.$api
        .getAPI({
          _action: '/payment/e-wallet/list',
        })
        .then(res => {
          this.e_wallet_payment_name_list = res.list;
        })
        .catch(e => {
          this.$refs.paymentErrorComonent.setTitle();
        });
    },

    kitchenPrinterSorting(e, sortBy) {
      var orderBy = 'ASC';

      var className = 'sorting_asc';
      var classes = e.target.className;
      if (classes.includes('sorting_asc')) {
        className = 'sorting_desc';
      }

      $('.sorting_asc').removeClass('sorting_asc');
      $('.sorting_desc').removeClass('sorting_desc');

      if (className == 'sorting_asc') {
        $(e.target)
          .addClass('sorting_asc')
          .removeClass('sorting_desc');
        orderBy = 'ASC';
      } else if (className == 'sorting_desc') {
        $(e.target)
          .addClass('sorting_desc')
          .removeClass('sorting_asc');
        orderBy = 'DESC';
      }
      this.getKitchenPrinters(sortBy, orderBy);
    },

    getKitchenPrinters(sortBy, orderBy) {
      this.checkedPrinters = [];

      var filterObj = {};
      if (sortBy) {
        filterObj.sort_by = sortBy;
      }

      if (orderBy) {
        filterObj.order_by = orderBy;
      }
      this.$api
        .getAPI({
          _action: '/backoffice-setting/list-kitchen-printers',
          _body: filterObj
        })
        .then(res => {
          this.printers = res.list;

          if (res.list != null && res.list.length > 0) {
            if (this.$refs.kitchenPrinterErrorComonent.isShowMessage()) {
              this.$refs.kitchenPrinterErrorComonent.setTitle();
            }
            this.checkUncheckKitchenPrinter();
          } else {
            this.$refs.kitchenPrinterErrorComonent.setTitle(
              this.$lang.messages.no_kitchen_printer_found
            );
          }
        })
        .catch(e => {
          console.log(e);
          this.$refs.kitchenPrinterErrorComonent.setTitle();
        });
    },

    getDinningOptions() {
      var filterObj = {};
      if (
        this.dinning_option_store_id &&
        this.dinning_option_store_id.length > 0
      ) {
        filterObj.store_id = this.dinning_option_store_id;
      }

      this.$api
        .getAPI({
          _action: '/backoffice-setting/get-dining-options',
          _body: filterObj
        })
        .then(res => {
          this.dinningOptions = res.list;

          if (!res.list || res.list.length <= 0) {
            this.$refs.dinningOptionErrorComonent.setTitle(
              this.$lang.messages.no_dinning_option_found
            );
          } else if (this.$refs.dinningOptionErrorComonent.isShowMessage()) {
            this.$refs.dinningOptionErrorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.dinningOptionErrorComonent.setTitle();
        });
    },

    getPayments() {
      var filterObj = {};
      if (
        this.payment_store_id &&
        this.payment_store_id.length > 0
      ) {
        filterObj.store_id = this.payment_store_id;
      }
      filterObj.is_ralali_payment = false
      this.$api
        .getAPI({
          _action: '/backoffice-setting/payment',
          _body: filterObj
        })
        .then(res => {
          this.payments = res.list;
          if (!res.list || res.list.length <= 0) {
            this.$refs.paymentErrorComonent.setTitle(
              this.$lang.messages.no_paymen_type_found
            );
          } else if (this.$refs.paymentErrorComonent.isShowMessage()) {
            this.$refs.paymentErrorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.paymentErrorComonent.setTitle();
        });
    },

    checkUncheckPayment(event, id, storeId, force_disable_delivery_option = null) {
      this.paymentId = id
      var isChecked = false;
      if (event.target.checked) {
        isChecked = true;
      }
      var body = {
        active: isChecked,
        id: id,
        force_disable_delivery_option,
        store_id: storeId
      };

      this.$api
        .putAPI({
          _action: '/backoffice-setting/payment/availability',
          _body: body
        })
        .then(res => {
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
          this.getPayments();
        }).catch(e => {
          this.getPayments();
        })
    },

    doConfirmcheckUncheckPayment(event = null) {
      var isChecked = false;
      var body = {
        active: isChecked,
        id: this.uncheckPaymentId,
        force_disable_delivery_option: null,
        store_id: this.uncheckPaymentStoreId
      };

      this.$api
        .putAPI({
          _action: '/backoffice-setting/payment/availability',
          _body: body
        })
        .then(res => {
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
          this.getPayments();
          this.$refs.confirmUncheckPayment.close();
        }).catch(e => {
          this.getPayments();
          this.$refs.confirmUncheckPayment.close();
        })
    },

    details(id) {
      //this.discount = {};
      this.selectedStores = [];
      this.$api
        .getAPI({
          _action: "/payment/detail/" + id
        })
        .then(res => {
          this.payment_type = res;
          this.e_wallet_payment = res.e_wallet_payment
          if (res.stores && res.stores.length > 0) {
            for (var i = 0; i < res.stores.length; i++) {
              if (res.stores[i].is_available) this.selectedStores.push(res.stores[i].store_id);
            }
            if (this.selectedStores.length == this.storeList.length) {
              this.isAll = true;
            }
          } else {
            this.selectedStores = [];
            this.isAll = false;
          }
          this.setAvailableStr();
        });
    },

    gotoPaymentEdit(id) {
      this.query = "";
      this.storeList = this.storeListOrigin;
      this.details(id);
      $("#AddPaymentType").modal("show");
    },

    confirmCheckUncheckPayment($event, id, store_id, value) {
      $event.stopPropagation();
      $event.preventDefault();
      this.uncheckPaymentId = id
      this.uncheckPaymentStoreId = store_id
      this.$refs.confirmUncheckPayment.message = this.$lang.messages.are_you_sure_you_want_to_disable_payment_type;
      $("#uncheck-payment-type-modal").modal("show");
    },

    setObj(id, storeId) {
      this.deletedPaymentId = id;
      this.deletedPaymentStoreId = storeId
      this.$refs.deletePaymentTypeAlert.message = this.$lang.messages.are_you_sure_you_want_to_delete_payment_type;
      if(this.$_.filter(this.$_.filter(this.payments, { store_id: storeId })[0].payments, function(o) {return o.active === 1 && o.payment_type != 'CASH' && o.payment_type != 'TUNAI'}).length > 1){
        this.$refs.deletePaymentTypeAlert.message = this.$lang.messages.delete_multiple_payment_types_message;
      }

    },

    checkUncheckDinningOption(event, id, force_disable_delivery_option = null) {
      this.dinningOptionId = id
      var isChecked = false;
      if (event.target.checked) {
        isChecked = true;
      }
      var body = {
        is_checked: isChecked,
        id: id,
        force_disable_delivery_option
      };

      this.$api
        .putAPI({
          _action: '/backoffice-setting/dinning-option/availability',
          _body: body
        })
        .then(res => {
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
          this.getDinningOptions();
        }).catch(e => {
          if (e.status == 409){
            this.$refs.forceDisableDeliveryOption.message = e.data.message
            $('#force-disable-delivery-option').modal('show')
          }
        })
    },
    checkUncheckDefaultDinningOption(event, id) {
      var isChecked = false;
      if (event.target.checked) {
        isChecked = true;
      }
      var body = {
        is_default: isChecked,
        id: id
      };
      this.$api
        .putAPI({
          _action: '/backoffice-setting/dinning-option/availability',
          _body: body
        })
        .then(res => {
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
          this.getDinningOptions();
        });
    },
    forceDisableDeliveryOption(e){
      this.$refs.forceDisableDeliveryOption.close();
      this.checkUncheckDinningOption({ target: { checked: false } }, this.dinningOptionId, true)
    },

    gotoAddKitchenPrinter() {
      this.$router.push('/add-kitchen-printer');
      this.$shareService.setMapValue('tab', 'settings-tab');
      this.$shareService.setMapValue('childTab', 'nav-tab7');
    },
    gotoKitchenPrinterEdit(id) {
      this.$router.push('/edit-kitchen-printer/' + id);
      this.$shareService.setMapValue('tab', 'settings-tab');
      this.$shareService.setMapValue('childTab', 'nav-tab7');
    },
    gotoAddDinningOption(e) {
      if (!this.checkPendingAccountStatus(e)) return
      this.$shareService.setMapValue('tab', 'settings-tab');
      this.$shareService.setMapValue('childTab', 'nav-tab8');
      this.$router.push('/add-dinning-option');
    },
    gotoDinningOptionEdit(id) {
      this.$shareService.setMapValue('tab', 'settings-tab');
      this.$shareService.setMapValue('childTab', 'nav-tab8');
      this.$router.push('/edit-dinning-option/' + id);
    },
    validateFilledValues(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          if (scope == 'open-ticket-form') {
            if (!this.open_ticket.list) {
              this.open_ticket.list = [];
            }
            var ticket = {
              name: ''
            };
            this.open_ticket.list.push(ticket);
          }
          return;
        }
      });
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          if (scope == 'general-setting-form') {
            this.saveGeneralSetting();
          } else if (scope == 'add-payment-type-form') {
            this.addPaymentType();
          } else if (scope == 'receipt-form') {
            this.saveReceiptDetails();
          } else if (scope == 'open-ticket-form') {
            this.saveOpenTicket();
          } else if (scope == 'jubelio-login-form'){
            this.loginJubelio();
          }
          return;
        }
      });
    },
    validateBusinessForm() {
      this.$validator.validateAll('business_form').then(result => {
        if (result) {
          this.saveBusinessInfo();
          return;
        }
      });
    },
    saveBusinessInfo() {
      var str = moment(String(this.client.person_info.date_of_birth)).format(
        'Y-M-D'
      );
      this.client.person_info.date_of_birth = str;
      if (this.client.person_info.date_of_birth == 'Invalid date') {
        alert('Please select date of birth');
        return false;
      }
      this.$api
        .postAPI({
          _action: '/business/update',
          _body: this.client
        })
        .then(res => {
          this.sendData();
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
          if (this.id_card) {
            this.uploadIdCard1(res.id);
          }
          if (this.id_card_with_photo) {
            this.uploadIdCardPhoto1(res.id);
          }
          let index = this.$_.findIndex(this.languages, {'id': this.client.business_info.ui_language})
          if(index != -1){
            let language = this.languages[index];
            localStorage.setItem('locale', language.code);
          }
          this.getDetail();
        });
    },
    saveReceiptDetails() {
      this.$api
        .postAPI({
          _action: '/backoffice-setting/save-receipt-setting',
          _body: this.receipt,
          _buttonId: 'receipt-save-btn'
        })
        .then(res => {
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
        });
    },
    saveGeneralSetting() {
      const that = this
      localStorage.setItem('cacheVersion', Date.now())
      this.$api
        .postAPI({
          _action: '/backoffice-setting/',
          _body: this.setting,
          _buttonId: 'general-save-btn'
        })
        .then(res => {
          this.sendData();
          this.getGeneralSetting();
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
        }).catch(e => {
          if (e.status == 406){
            this.$refs.forceSaveStorefront.message = e.data.message;
            $('#force-save-storefront-modal').modal('show');
          }
          if (e.status == 409){
            this.$refs.forceSaveDiningOption.message = e.data.message;
            $('#force-save-dining-options-modal').modal('show');
          }
        });
    },
    forceSaveStorefront(e){
      this.setting.force_disable_storefront = true
      this.$refs.forceSaveStorefront.close();
      this.saveGeneralSetting()
    },
    forceSaveDiningOption(e){
      this.setting.force_disable_dining_options = true
      this.$refs.forceSaveDiningOption.close();
      this.saveGeneralSetting()
    },
    sendData() {
      const payload = {
        action: 'test'
      };
      EventBus.$emit('DATA_PUBLISHED', payload);
    },
    getGeneralSetting() {
      this.$api
        .getAPI({
          _action: '/backoffice-setting/general',
          _hide_loader: true
        })
        .then(async res => {
          this.setting = res;
          localStorage.setItem('dining_options', this.setting.dining_options);
          localStorage.setItem('is_enable_b2b', this.setting.is_enable_b2b);
          localStorage.setItem('customer_sharing', this.setting.customer_sharing);
          localStorage.setItem('storefront', this.setting.storefront);
          if (this.setting.decimal_separator != null) {
            if (this.setting.decimal_separator == 'DOT') {
              localStorage.setItem('decimal_separator', ',');
            } else if (res.decimal_separator == 'COMMA') {
              localStorage.setItem('decimal_separator', '.');
            } else {
              localStorage.setItem('decimal_separator', '');
            }
          }

          if (res.country_id) {
            await this.getTimeZoneList(res.country_id);
            await this.getBankList(res.country_id);
          }

          this.actualSetting.kitchen_printers = this.setting.kitchen_printers;
          this.actualSetting.dining_options = this.setting.dining_options;
          this.actualSetting.open_tickets = this.setting.open_tickets;

          setTimeout(() => {
            if (this.$shareService.getMapValue('tab')) {
              document
                .getElementById(this.$shareService.getMapValue('tab'))
                .click();
              this.$shareService.deleteMapValue('tab');
              if (this.$shareService.getMapValue('childTab')) {
                document
                  .getElementById(this.$shareService.getMapValue('childTab'))
                  .click();
                this.$shareService.deleteMapValue('childTab');
              }
            }
          }, 200);
        });
    },
    getBankList(country_id) {
      this.$api
        .getAPI({
          _action: '/bank/list/' + country_id,
          _hide_loader: true
        })
        .then(res => {
          this.bankList = res.list;
        });
    },
    selectMainTab(tab) {
      if (tab == 'PAYMENT_TYPE') {
        this.getPayments();
        this.getEwalletPaymentName();
        this.checkedPaymentTypes = [];
      } else if (tab == 'TAXES') {
      } else if (tab == 'RECEIPT') {
        if (this.all_stores != null && this.all_stores.length > 0) {
          this.receipt_store_id = this.all_stores[0].id;
          this.getReceiptDetails();
        }
      } else if (tab == 'KITCHEN_PRINTERS') {
        this.getKitchenPrinters();
      } else if (tab == 'DINNING_OPTIONS') {
        this.getDinningOptions();
      } else if (tab == 'OPEN_TICKETS') {
        if (this.all_stores != null && this.all_stores.length > 0) {
          this.open_tickets_store_id = this.all_stores[0].id;
          this.getOpenTicketDetails();
        }
      } else if (tab == 'SUBSCRIPTION') {
        this.getSubscription();
      }else if (tab == 'JUBELIO'){
        this.getJubelioInfo();
      }
    },
    getSubscription() {
      this.$api
        .getAPI({
          _action: '/business_subscription/subscription_list',
          _hide_loader: true
        })
        .then(res => {
          this.subscription_list = res.list;
          if (!res.list || res.list.length <= 0) {
            this.$refs.subscriptionErrorComonent.setTitle(
              'No Subscribtion Found'
            );
          } else if (this.$refs.subscriptionErrorComonent.isShowMessage()) {
            this.$refs.subscriptionErrorComonent.setTitle();
          }
        });
    },
    getJubelioInfo() {
      this.$api
        .getAPI({
          _action: '/integration/jubelio/detail',
          _hide_loader: true
        })
        .then(res => {
          console.log('res', res, !!res.email)
            this.jubelio = res
            if(this.jubelio.status == 'ACTIVE'){
              this.getContacts();
              this.getLocations();
              this.jubelioInventoryItem(1)
            }
        });
    },
    getContacts() {
      this.$api
        .getAPI({
          _action: '/integration/jubelio/contact',
          _hide_loader: true
        })
        .then(res => {
            this.jubelioContacts = res
        });
    },
    getLocations() {
      this.$api
        .getAPI({
          _action: '/integration/jubelio/location',
          _hide_loader: true
        })
        .then(res => {
            this.jubelioLocations = res
        });
    },
    setKitchenPrinterObj(obj, message) {
      this.checkedPrinters = [];
      this.printer = obj;
      this.$refs.deleteKitchenPrinterAlert.message = message;
      this.$refs.deleteKitchenPrinterAlert.setValue(obj);
      this.checkedPrinters.push(obj.id);
      this.checkUncheckKitchenPrinter();
    },

    deletePaymentType(e) {
      this.$api
        .deleteAPI({
          _action: `/payment/${this.deletedPaymentId}/${this.deletedPaymentStoreId}`
        })
        .then(res => {
          // this.payment_type_obj = {};
          this.$refs.deletePaymentTypeAlert.close();
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
          this.getPayments();
        })
        .catch(e => {
          this.$refs.deletePaymentTypeAlert.close();
        });
    },
    addPaymentType() {
      if (this.selectedStores.length > 0) {
        this.payment_type.stores = this.selectedStores;
      } else {
        this.payment_type.stores = [];
      }
      this.payment_type.e_wallet_payment = this.e_wallet_payment
      this.payment_type.e_wallet_other_name = this.e_wallet_other_payment_name
      this.$api
        .postAPI({
          _action: '/payment/',
          _body: this.payment_type,
          _buttonId: 'payment-type-save-btn'
        })
        .then(res => {
          document.getElementById('payment-type-cancel-btn').click();
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
          this.getPayments();
        });
    },
    setEditPaymentType(paymentType) {
      this.clearAddPaymentTypeModal(this.$lang.messages.edit);
      this.payment_type.name = paymentType.name;
      this.payment_type.payment_type = paymentType.payment_type;

      if (paymentType.id) {
        this.payment_type.id = paymentType.id;
      }
    },
    clearAddPaymentTypeModal(operationType, e = null) {
      this.selectedStores = [];
      this.paymentTypeOperation = operationType;
      this.payment_type = {
        name: '',
        payment_type: '',
        id: null
      };
      this.e_wallet_payment = null;
      this.isAll = true;
      this.checkAllStores();
      this.$validator.reset();
      this.errors.clear();
    },

    gotoAddstore(e) {
      if (e && !this.checkPendingAccountStatus(e)) return
      this.$router.push('/add-store');
      this.$shareService.setMapValue('tab', 'stores-tab');
      this.$shareService.setMapValue('childTab', 'nav-tab1-link');
    },
    getStoreList(sortBy, orderBy) {
      this.stores = [];

      var filterObj = {};

      if (sortBy) {
        filterObj.sort_by = sortBy;
      }

      if (orderBy) {
        filterObj.order_by = orderBy;
      }
      this.$api
        .getAPI({
          _action: '/store/get_back_office',
          _body: filterObj
        })
        .then(res => {
          this.stores = res.list;
          if (!res.list || res.list.length <= 0) {
            this.$refs.storeErrorComonent.setTitle(
              this.$lang.messages.no_stores_found
            );
          } else if (this.$refs.storeErrorComonent.isShowMessage()) {
            this.$refs.storeErrorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.storeErrorComonent.setTitle();
        });
    },

    checkUncheckStore(event) {
      this.setAvailableStr();
      if (event && !event.target.checked) {
        this.isAll = false;
      }
    },
    checkAllStores(event) {
      this.availableStoreStr = "";
      if (this.isAll) {
        for (var i = 0; i < this.storeList.length; i++) {
          if(this.selectedStores.indexOf(this.storeList[i].id) == -1){
            this.selectedStores.push(this.storeList[i].id);
          }
        }
      }else{
        for (var i = 0; i < this.storeList.length; i++) {
          this.selectedStores = this.selectedStores.filter(item => item !== this.storeList[i].id)
        }
      }
      this.setAvailableStr();
    },
    setAvailableStr() {
      this.availableStoreStr = "";
      var nAvailableStore = 0;
      for(let i=0; i<this.selectedStores.length; i++){
        if(this.$_.findIndex(this.storeListOrigin, {'id': this.selectedStores[i]}) != -1){
          nAvailableStore += 1
        }
      }
      this.isAll = false
      if(nAvailableStore == this.storeListOrigin.length){
        this.isAll = true
      }
      if (this.selectedStores.length > 0) {
        if (this.isAll) {
          this.availableStoreStr = this.$lang.messages.available_in_all_stores;
        } else {
          if (nAvailableStore == 1) {
            this.availableStoreStr = `${this.$lang.messages.available_in} 1 ${this.$lang.messages.store.toLowerCase()}`;
          } else if(nAvailableStore > 0) {
            this.availableStoreStr = `${this.$lang.messages.available_in} ${nAvailableStore} ${this.$lang.messages.stores.toLowerCase()}`;
          }
        }
      }
    },
    searchStores(event) {
      if(this.query == ""){
        this.storeList = this.storeListOrigin
      }else{
        this.storeList = this.$flowFilter(this.storeListOrigin, this.query);
      }
    },

    kitchenPrinterRetry() {
      this.getKitchenPrinters();
    },
    storeRetry() {
      this.getStoreList();
    },

    taxRetry() {
    },
    dinningOptionRetry() {
      this.getDinningOptions();
    },
    paymentRetry() {
      this.getPayments();
    },
    getAllLanguageList() {
      this.$api
        .getAPI({
          _action: '/language/list',
          _hide_loader: true
        })
        .then(res => {
          this.languages = res.list;
        });
    },
    getAllStoreList() {
      this.$api
        .getAPI({
          _action: '/store/list',
          _hide_loader: true
        })
        .then(res => {
          this.all_stores = res.list;
          this.storeList = res.list;
          this.storeListOrigin = res.list;
        });
    },
    clickMainTab(mainTab) {
      if (mainTab == 'STORE') {
        if(this.access_right.manage_stores) {
          this.getStoreList();
          this.getGeneralSetting()
        }else{
          document.getElementById('nav-tab2-link').click();
        }
      }
    },
    clickStoreAndPosSettingTab(selectedTab) {
      this.settingOnlineStorefront = false
      this.settingSobatCategory = false
      if (selectedTab == 'STOREFRONT') {
        this.settingOnlineStorefront = true
      }
      if (selectedTab == 'SOBAT_CATEGORY') {
        this.settingSobatCategory = true
      }

      if (selectedTab == 'POS') {
        this.getPOSList();
      } else if (selectedTab == 'Menu') {
        this.getMenuList();
      } else {
        this.getStoreList();
      }
    },
    gotoStoreEdit(id) {
      this.$router.push('/edit-store/' + id);
      this.$shareService.setMapValue('tab', 'stores-tab');
      this.$shareService.setMapValue('childTab', 'nav-tab1-link');
    },

    posRetry() {
      this.getPOSList();
    },
    subscriptionRetry() {
      this.getSubscription();
    },
    getPOSList(sortBy, orderBy) {
      this.pos_list = [];
      var filterObj = {};
      if (this.store_id) {
        filterObj.store_id = this.store_id;
      }

      if (sortBy) {
        filterObj.sort_by = sortBy;
      }

      if (orderBy) {
        filterObj.order_by = orderBy;
      }

      this.$api
        .getAPI({
          _action: '/pos/list',
          _body: filterObj
        })
        .then(res => {
          this.pos_list = res.list;
          if (!res.list || res.list.length <= 0) {
            this.$refs.posErrorComonent.setTitle(
              this.$lang.messages.no_pos_devices_found
            );
          } else if (this.$refs.posErrorComonent.isShowMessage()) {
            this.$refs.posErrorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.posErrorComonent.setTitle();
        });
    },
    gotoAddPOS(e) {
      if (!this.checkPendingAccountStatus(e)) return

      this.$router.push('/add-pos');
      this.$shareService.setMapValue('tab', 'stores-tab');
      this.$shareService.setMapValue('childTab', 'nav-tab2-link');
    },
    gotoPOSEdit(id) {
      this.$router.push('/edit-pos/' + id);
      this.$shareService.setMapValue('tab', 'stores-tab');
      this.$shareService.setMapValue('childTab', 'nav-tab2-link');
    },
    deletePOS(event) {
      this.$api
        .deleteAPI({
          _action: '/pos/delete/' + this.pos_obj.id
        })
        .then(res => {
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
          this.getPOSList();
          this.$refs.deletePOSAlert.close();
        })
        .catch(e => {
          this.$refs.deletePOSAlert.close();
        });
    },
    showSubscriptionAlert(type, subscription) {
      var message = '';
      if (type == 'SUBSCRIBE') {
        this.subscription_id = subscription.id;
        message = 'Subscribe';
        this.$refs.subscrideSubscriptionLink.click();
        this.$refs.subscrideSubscriptionAlert.message =
          'Are you sure want to ' + message + ' the Subscription ?';
      } else {
        this.subscription_id = subscription.business_subscription_id;
        message = 'Unsubscribe';
        this.$refs.unsubscrideSubscriptionLink.click();
        this.$refs.unsubscrideSubscriptionAlert.message =
          'Are you sure want to ' + message + ' the Subscription ?';
      }
    },
    unSubscription(event) {
      if (this.subscription_id) {
        this.$api
          .postAPI({
            _action:
              '/business_subscription/unsubscription/' + this.subscription_id
          })
          .then(res => {
            this.$notify({
              group: 'foo',
              text: res.message,
              type: 'success'
            });
            this.getSubscription();
            this.$refs.unsubscrideSubscriptionAlert.close();
          })
          .catch(e => {
            this.$refs.unsubscrideSubscriptionAlert.close();
          });
      }
    },
    addSubscription(event) {
      var obj = {
        business_id: this.client_id,
        subscription_id: this.subscription_id,
        user_type: 'OWNER'
      };
      this.$api
        .postAPI({
          _action: '/business_subscription/',
          _body: obj
        })
        .then(res => {
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
          this.getSubscription();
          this.$refs.subscrideSubscriptionAlert.close();
        })
        .catch(e => {
          this.$refs.subscrideSubscriptionAlert.close();
        });
    },
    releasePOS(event) {
      this.$api
        .postAPI({
          _action: '/pos/release/' + this.pos_obj.id
        })
        .then(res => {
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
          this.getPOSList();
          this.$refs.releasePOSAlert.close();
        })
        .catch(e => {
          this.$refs.releasePOSAlert.close();
        });
    },

    menuRetry() {
      this.getMenuList();
    },
    getMenuList(sortBy, orderBy) {
      this.menu_list = [];
      var filterObj = {};
      if (this.store_id) {
        filterObj.store_id = this.store_id;
      }

      if (sortBy) {
        filterObj.sort_by = sortBy;
      }

      if (orderBy) {
        filterObj.order_by = orderBy;
      }

      this.$api
        .getAPI({
          _action: '/menuApp/list',
          _body: filterObj
        })
        .then(res => {
          this.menu_list = res.list;
          if (!res.list || res.list.length <= 0) {
            this.$refs.menuErrorComonent.setTitle(
              this.$lang.messages.no_menu_devices_found
            );
          } else if (this.$refs.menuErrorComonent.isShowMessage()) {
            this.$refs.menuErrorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.menuErrorComonent.setTitle();
        });
    },
    gotoAddMenu() {
      this.$router.push('/add-menu');
      this.$shareService.setMapValue('tab', 'stores-tab');
      this.$shareService.setMapValue('childTab', 'nav-tab3-link');
    },
    gotoMenuEdit(id) {
      this.$router.push('/edit-menu/' + id);
      this.$shareService.setMapValue('tab', 'stores-tab');
      this.$shareService.setMapValue('childTab', 'nav-tab3-link');
    },
    deleteMenu(event) {
      this.$api
        .deleteAPI({
          _action: '/menuApp/' + this.menu_obj.id
        })
        .then(res => {
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
          this.getMenuList();
          this.$refs.deleteMenuAlert.close();
        })
        .catch(e => {
          this.$refs.deleteMenuAlert.close();
        });
    },

    deleteStore(event) {
      this.$api
        .deleteAPI({
          _action: '/store/delete/' + this.store.id
        })
        .then(res => {
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
          this.getStoreList();
          this.$refs.deleteStoreAlert.close();
        })
        .catch(e => {
          this.$refs.deleteStoreAlert.close();
        });
    },

    setPOSObj(obj, message) {
      this.pos_obj = obj;
      this.$refs.deletePOSAlert.message = message;
      this.$refs.deletePOSAlert.setValue(obj);
    },
    releasePOSObj(obj, message) {
      this.pos_obj = obj;
      this.$refs.releasePOSAlert.message = message;
      this.$refs.releasePOSAlert.setValue(obj);
    },
    setMenuObj(obj, message) {
      this.menu_obj = obj;
      this.$refs.deleteMenuAlert.message = message;
      this.$refs.deleteMenuAlert.setValue(obj);
    },

    setStoreObj(obj, message) {
      this.store = obj;
      this.$refs.deleteStoreAlert.message = message;
      this.$refs.deleteStoreAlert.setValue(obj);
    },
    paymentTypeSorting(e, sortBy) {
      var orderBy = 'ASC';

      var className = 'sorting_asc';
      var classes = e.target.className;
      if (classes.includes('sorting_asc')) {
        className = 'sorting_desc';
      }

      $('.sorting_asc').removeClass('sorting_asc');
      $('.sorting_desc').removeClass('sorting_desc');

      if (className == 'sorting_asc') {
        $(e.target)
          .addClass('sorting_asc')
          .removeClass('sorting_desc');
        orderBy = 'ASC';
      } else if (className == 'sorting_desc') {
        $(e.target)
          .addClass('sorting_desc')
          .removeClass('sorting_asc');
        orderBy = 'DESC';
      }
      this.getPayments(sortBy, orderBy);
    },
    storeSorting(e, sortBy) {
      var orderBy = 'ASC';

      var className = 'sorting_asc';
      var classes = e.target.className;
      if (classes.includes('sorting_asc')) {
        className = 'sorting_desc';
      }

      $('.sorting_asc').removeClass('sorting_asc');
      $('.sorting_desc').removeClass('sorting_desc');

      if (className == 'sorting_asc') {
        $(e.target)
          .addClass('sorting_asc')
          .removeClass('sorting_desc');
        orderBy = 'ASC';
      } else if (className == 'sorting_desc') {
        $(e.target)
          .addClass('sorting_desc')
          .removeClass('sorting_asc');
        orderBy = 'DESC';
      }
      this.getStoreList(sortBy, orderBy);
    },
    posSorting(e, sortBy) {
      var orderBy = 'ASC';

      var className = 'sorting_asc';
      var classes = e.target.className;
      if (classes.includes('sorting_asc')) {
        className = 'sorting_desc';
      }

      $('.sorting_asc').removeClass('sorting_asc');
      $('.sorting_desc').removeClass('sorting_desc');

      if (className == 'sorting_asc') {
        $(e.target)
          .addClass('sorting_asc')
          .removeClass('sorting_desc');
        orderBy = 'ASC';
      } else if (className == 'sorting_desc') {
        $(e.target)
          .addClass('sorting_desc')
          .removeClass('sorting_asc');
        orderBy = 'DESC';
      }
      this.getPOSList(sortBy, orderBy);
    },
    menuSorting(e, sortBy) {
      var orderBy = 'ASC';

      var className = 'sorting_asc';
      var classes = e.target.className;
      if (classes.includes('sorting_asc')) {
        className = 'sorting_desc';
      }

      $('.sorting_asc').removeClass('sorting_asc');
      $('.sorting_desc').removeClass('sorting_desc');

      if (className == 'sorting_asc') {
        $(e.target)
          .addClass('sorting_asc')
          .removeClass('sorting_desc');
        orderBy = 'ASC';
      } else if (className == 'sorting_desc') {
        $(e.target)
          .addClass('sorting_desc')
          .removeClass('sorting_asc');
        orderBy = 'DESC';
      }
      this.getMenuList(sortBy, orderBy);
    },

    gotoAddTax() {
      this.$router.push('/add-tax');
      this.$shareService.setMapValue('tab', 'settings-tab');
      this.$shareService.setMapValue('childTab', 'nav-tab4');
    },

    gotoTaxEdit(id) {
      this.$router.push('/edit-tax/' + id);
      this.$shareService.setMapValue('tab', 'settings-tab');
      this.$shareService.setMapValue('childTab', 'nav-tab4');
    },
    getReceiptDetails(isFromImageUplod) {
      this.$api
        .getAPI({
          _action:
            '/backoffice-setting/get-receipt-setting/' + this.receipt_store_id
        })
        .then(res => {
          if (isFromImageUplod) {
            if (res.printed_receipt != null) {
              this.receipt.printed_receipt = res.printed_receipt;
            }

            if (res.emailed_receipt != null) {
              this.receipt.emailed_receipt = res.emailed_receipt;
            }
          } else {
            this.receipt = res;
          }
        });
    },
    saveOpenTicket() {
      if (this.open_ticket.use_predefined_tickets) {
        if (this.open_ticket.list != null && this.open_ticket.list.length > 0) {
          for (var i = 0; i < this.open_ticket.list.length; i++) {
            this.open_ticket.list[i].priority = i + 1;
          }
        }
      } else {
        this.open_ticket.list = [];
      }
      this.open_ticket.store_id = this.open_tickets_store_id;

      this.$api
        .postAPI({
          _action: '/backoffice-setting/save-open-ticket',
          _body: this.open_ticket,
          _buttonId: 'receipt-save-btn'
        })
        .then(res => {
          this.getOpenTicketDetails();
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
        });
    },
    loginJubelio() {
      this.$api
        .postAPI({
          _action: '/integration/jubelio',
          _body: this.jubelio,
          _buttonId: 'jubelio-login-btn'
        })
        .then(res => {
          this.getJubelioInfo();
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
        });
    },
    getOpenTicketDetails() {
      this.$api
        .getAPI({
          _action:
            '/backoffice-setting/get-open-ticket/' + this.open_tickets_store_id,
          _show_loader: true
        })
        .then(res => {
          this.open_ticket = res;
          if (res.list == null || res.list.length < 1) {
            this.open_ticket.list = [];
          }
        });
    },

    checkUncheckPredefinedTickets(e) {
      this.$validator.reset();
      this.errors.clear();
    },

    deleteTicket(index) {
      this.open_ticket.list.splice(index, 1);
    },
    onChange(e, type) {
      let files = e.target.files;
      this.file = files[0];

      if (e.target.files && e.target.files[0]) {
        var reader = new FileReader();

        reader.onload = function(e) {
          if (type == 'EMAIL_RECEIPT') {
            $('#img_hoder_1').attr('src', e.target.result);
          } else {
            $('#img_hoder_2').attr('src', e.target.result);
          }
        };
        reader.readAsDataURL(e.target.files[0]);
      }

      if (this.file) {
        this.uploadFiles(type);
      }
    },
    uploadFiles(type) {
      var url = '';
      var key = '';
      if (type == 'EMAIL_RECEIPT') {
        url = '/backoffice-setting/upload-emailed-receipt/';
        key = 'emailed_receipt';
      } else if (type == 'PRINTED_RECEIPT') {
        url = '/backoffice-setting/upload-printed-receipt/';
        key = 'printed_receipt';
      }
      url += this.receipt_store_id;
      this.$api
        .uploadImageAPI({
          _action: url,
          _key: key,
          _file: this.file
        })
        .then(res => {
          if (type == 'EMAIL_RECEIPT') {
              this.receipt.emailed_receipt = res.emailed_receipt;
          } else if (type == 'PRINTED_RECEIPT') {
              this.receipt.printed_receipt = res.printed_receipt;
          }

          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
        });
    },
    getDetail() {
      this.$api
        .getAPI({
          _action: '/get_business_detail/' + this.owner_id
        })
        .then(res => {
          this.client = res;
          var date = new Date(
            moment(this.client.person_info.date_of_birth, 'YYYY-MM-DD').get(
              'year'
            ),
            moment(this.client.person_info.date_of_birth, 'YYYY-MM-DD').get(
              'month'
            ),
            moment(this.client.person_info.date_of_birth, 'YYYY-MM-DD').get(
              'date'
            )
          );

          if (date && date != 'Invalid Date') {
            this.client.person_info.date_of_birth = date;
          } else {
            this.client.person_info.date_of_birth = new Date(
              this.client.person_info.date_of_birth
            );
          }
          this.client_id = res.business_info.id;
          if (res.business_info.country_id) {
            this.getLanguage(res.business_info.country_id);
            this.getTimeZoneList(res.business_info.country_id);
            this.getStateList(res.business_info.country_id, false, 'BUSINESS');
          }
          if (res.business_info.state_id) {
            this.getDistrictList(res.business_info.state_id, false, 'BUSINESS');
          }
          if (res.business_info.district_id) {
            this.getCityList(res.business_info.district_id, false, 'BUSINESS');
          }
          if (res.person_info.country_id) {
            this.getStateList(res.person_info.country_id, false, 'PERSON');
          }
          if (res.person_info.state_id) {
            this.getDistrictList(res.person_info.state_id, false, 'PERSON');
          }
          if (res.person_info.district_id) {
            this.getCityList(res.person_info.district_id, false, 'PERSON');
          }
          if (res.person_info.city_id) {
            this.getVillageList(res.person_info.city_id, false, 'PERSON');
          }

          this.getBusinessType();
        })
        .catch(e => {});
    },
    getStateList(country_id, is_change, type) {
      if (country_id) {
        if (is_change && type == 'BUSINESS') {
          this.client.business_info.state_id = '';
          this.client.business_info.district_id = '';
          this.client.business_info.city_id = '';
        }

        if (is_change && type == 'PERSON') {
          this.client.person_info.state_id = '';
          this.client.person_info.district_id = '';
          this.client.person_info.city_id = '';
          this.client.person_info.village_id = '';
        }
        this.$api
          .getAPI({
            _action: '/state/list/' + country_id
          })
          .then(res => {
            if (type == 'BUSINESS') {
              this.stateList = res.list;
            }
            if (type == 'PERSON') {
              this.personstateList = res.list;
            }
          })
          .catch(e => {});
      }
    },
    getdata(country_id) {
      if (country_id) {
        this.getLanguage(country_id);
        this.getTimeZoneList(country_id);
      }
    },

    getDistrictList(state_id, is_change, type) {
      if (state_id) {
        if (is_change && type == 'BUSINESS') {
          this.client.business_info.district_id = '';
          this.client.business_info.city_id = '';
        }
        if (is_change && type == 'PERSON') {
          this.client.person_info.district_id = '';
          this.client.person_info.city_id = '';
          this.client.person_info.village_id = '';
        }
        this.$api
          .getAPI({
            _action: '/district/list/' + state_id
          })
          .then(res => {
            if (type == 'BUSINESS') {
              this.districtList = res.list;
            }
            if (type == 'PERSON') {
              this.persondistrictList = res.list;
            }
          })
          .catch(e => {});
      }
    },

    getCityList(district_id, is_change, type) {
      if (district_id) {
        if (is_change && type == 'BUSINESS') {
          this.client.business_info.city_id = '';
        }
        if (is_change && type == 'PERSON') {
          this.client.person_info.city_id = '';
          this.client.person_info.village_id = '';
        }

        this.$api
          .getAPI({
            _action: '/city/list/' + district_id
          })
          .then(res => {
            if (type == 'BUSINESS') {
              this.cityList = res.list;
            }
            if (type == 'PERSON') {
              this.personcityList = res.list;
            }
          })
          .catch(e => {});
      }
    },

    getVillageList(city_id, is_change) {
      if (city_id) {
        if (is_change) {
          this.client.person_info.village_id = '';
        }

        this.$api
          .getAPI({
            _action: '/village/list/' + city_id
          })
          .then(res => {
            this.villageList = res.list;
          })
          .catch(e => {});
      }
    },
    getCountryList() {
      this.$api
        .getAPI({
          _action: '/country/list'
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.countryList = res.list;
          }
        })
        .catch(e => {});
    },
    getTimeZoneList(country_id) {
      if (country_id) {
        this.$api
          .getAPI({
            _action: '/timezone/list/' + country_id,
            _hide_loader: true
          })
          .then(res => {
            this.timezones = res.list;
          });
      }
    },
    getLanguage(country_id) {
      if (country_id) {
        this.$api
          .getAPI({
            _action: '/language/list'
          })
          .then(res => {
            this.languageList = res.list;
          })
          .catch(e => {});
      }
    },
    getBusinessType(flag) {
      if (this.client.business_info.ui_language) {
        if (flag) {
          // this.client.business_info.sub_business_type_id = '';
          // this.client.business_info.business_type_id = '';
        }
        this.$api
          .getAPI({
            _action:
              '/business_type/list/' + this.client.business_info.ui_language
          })
          .then(res => {
            this.businessList = res.list;
            this.getSubBusinessType(false);
          })
          .catch(e => {});
      }
    },
    getSubBusinessType(is_change) {
      if (is_change) {
        // this.client.business_info.sub_business_type_id = '';
      }

      if (
        this.client.business_info.business_type_id &&
        this.client.business_info.ui_language
      ) {
        this.$api
          .getAPI({
            _action:
              '/sub_business_type/list/' +
              this.client.business_info.business_type_id +
              '/' +
              this.client.business_info.ui_language
          })
          .then(res => {
            this.subbusinessList = res.list;
          })
          .catch(e => {});
      }
    },
    onIdCardPhotoChange(e) {
      let files = e.target.files;
      this.id_card_with_photo = files[0];

      if (e.target.files && e.target.files[0]) {
        var reader = new FileReader();
        reader.onload = function(e) {
          $('#id_card_with_photo').attr('src', e.target.result);
        };
      }
      reader.readAsDataURL(e.target.files[0]);
    },

    onIdCardChange(e) {
      let files = e.target.files;
      this.id_card = files[0];

      if (e.target.files && e.target.files[0]) {
        var reader = new FileReader();
        reader.onload = function(e) {
          $('#id_card').attr('src', e.target.result);
        };
      }
      reader.readAsDataURL(e.target.files[0]);
    },

    uploadIdCard1(id) {
      this.$api
        .uploadImageAPI({
          _action: '/id_card/' + id,
          _key: 'id_card',
          _file: this.id_card
        })
        .then(res => {
          this.id_card = '';
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
        });
    },

    uploadIdCardPhoto1(id) {
      this.$api
        .uploadImageAPI({
          _action: '/id_card_with_photo/' + id,
          _key: 'id_card_with_photo',
          _file: this.id_card_with_photo
        })
        .then(res => {
          this.id_card_with_photo = '';
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
        });
    },
    jubelioUpdate(){
      var bodydata = this.jubelio
      this.$api
        .postAPI({
          _action: '/integration/jubelio/update',
          _body: bodydata,
        })
        .then(res => {
            this.getJubelioInfo()
        })
        .catch(e => {
          console.log(e.message);
        });
    },
    jubelioInventoryItem(page){
      this.currentPage = page;
      this.$api
        .getAPI({
          _action: `/integration/jubelio/inventory/items?page=${this.currentPage}&page_size=${this.itemsPerPage}&q=${this.query}&item_type=${this.jubelio_item_type}`,
        })
        .then(res => {
            this.jubelioItemsData = res;
            this.$refs.listPagination.setTotalCount(res.count);
            this.$refs.listPagination.setCurrentPage(this.currentPage);
        })
        .catch(e => {
        });
    },

    onActiveSettingTab(slug = this.$route.params.slug) {
      if (!slug) return

      switch(slug) {
        case 'online-storefront':
          setTimeout(() => {
            $('#stores-tab').click()
            this.clickMainTab('STORE')
          }, 5000)
          setTimeout(() => {
            $('#nav-tab4-link').click()
            this.clickStoreAndPosSettingTab('STOREFRONT')
          }, 5000)
          break
        case 'sobat-category':
          setTimeout(() => {
            $('#stores-tab').click()
            this.clickMainTab('STORE')
          }, 5000)
          setTimeout(() => {
            $('#nav-tab5-link').click()
            this.clickStoreAndPosSettingTab('SOBAT_CATEGORY')
          }, 5000)
          break
        default:
          setTimeout(() => { $('#settings-tab').click() }, 1000)
          setTimeout(() => { $('#nav-tab10').click() }, 1000)
      }
    },

    onUpdateEmployeePassword() {
      this.$validator.validateAll('employeeChangePasswordForm').then(result => {
        if (!result) return

        this.$api
          .postAPI({
            _action: '/employee/change_password',
            _body: this.employeeChangePassword
          })
          .then(res => {
            this.$notify({
              group: 'foo',
              text: res.message,
              type: 'success'
            })

            this.showChangePasswordAlert()
          })
          .catch(error => {
            console.log(error)
          })
      })
    },

    toggleShowHidePassword() {
      $(document).ready(function() {
        $('.show_hide_password').each(function() {
          var $this = $(this)

          $this.find('a').on('click', function(event) {
            event.preventDefault()
            if ($this.find('input').attr('type') == 'text') {
              $this.find('input').attr('type', 'password')
              $this.find('i').addClass('fa-eye-slash')
              $this.find('i').removeClass('fa-eye')
            } else if ($this.find('input').attr('type') == 'password') {
              $this.find('input').attr('type', 'text')
              $this.find('i').removeClass('fa-eye-slash')
              $this.find('i').addClass('fa-eye')
            }
          })
        })
      })
    },

    notStartWithZeroValidation() {
      this.$validator.extend('notStartWithZero', {
        validate: (value) => {
          if (!value.startsWith('0', 0)) return true
          return false
        }
      })
    }
  },

  async created() {
    await this.getMe()
    await this.getAllLanguageList()
    await this.getGeneralSetting()
    await this.getAllStoreList()
    await this.getCountryList()
    await this.getSubscription()
    this.notStartWithZeroValidation()

    // get mobile setting check
    EventBus.$emit('MOBILE_SETTING_CHECK_DONE', this.mobileSetting)
  },

  mounted() {
    this.clickStoreAndPosSettingTab('POS');
    this.onActiveSettingTab()
    $('.nav-link').click(function(e) {
      $('.sorting_asc').removeClass('sorting_asc')
      $('.sorting_desc').removeClass('sorting_desc')
    })
    this.country_code = localStorage.getItem('country_code')

    this.toggleShowHidePassword()

    // get currentUser
    EventBus.$on('GET_ME_SUCCESS', payload => {
      this.currentUser = payload
    })
  },

  watch: {
    '$route'(to, from) {
      this.onActiveSettingTab(to.params.slug)
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.settingOnlineStorefront && this.settingOnlineStorefrontNeedConfirm) {
      const answer = window.confirm(this.$lang.messages.unsaved_change_message)
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
}
</script>

<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="tab-style-2">
              <ul class="nav nav-pills mb-4" id="pills-tab" role="tablist" v-show="!mobileSetting">
                <li class="nav-item mr-lg-4 mr-1 mb-lg-0 mb-2">
                  <a
                    class="nav-link active media"
                    id="settings-tab"
                    data-toggle="pill"
                    href="#settings"
                    role="tab"
                    aria-controls="settings"
                    aria-selected="true"
                  >
                    <img src="/images/icon_settings.svg" class="mr-lg-3 mr-2 pt-2" />
                    <div class="media-body" style="line-height: 23px">
                      <span class="font-22 label-1">{{$lang.messages.settings}}</span>
                      <span class="font-16 d-block label-2">{{$lang.messages.system_settings}}</span>
                    </div>
                  </a>
                </li>
                <li class="nav-item" v-if="access_right.manage_pos">
                  <a
                    class="nav-link media"
                    id="stores-tab"
                    data-toggle="pill"
                    href="#stores"
                    role="tab"
                    aria-controls="stores"
                    aria-selected="false"
                    @click="clickMainTab('STORE')"
                  >
                    <img src="/images/icon_store.svg" class="mr-lg-3 mr-2 pt-2" />
                    <div class="media-body" style="line-height: 23px">
                      <span class="font-22 label-1">{{$lang.messages.stores}}</span>
                      <span
                        class="font-16 d-block label-2"
                      >{{$lang.messages.store_and_pos_settings}}</span>
                    </div>
                  </a>
                </li>
              </ul>
              <div class="tab-content bg-white mb-4 border rounded-5" id="pills-tabContent">
                <div
                  class="tab-pane fade show active"
                  id="settings"
                  role="tabpanel"
                  aria-labelledby="settings-tab"
                  v-show="!mobileSetting">
                  <div class="report-tab settings-inner-tab">
                    <nav class="mb-4 mt-3">
                      <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                          v-if="access_right.edit_profile"
                          :class="access_right.edit_profile ? 'active' : ''"
                          class="nav-item nav-link text-center"
                          id="nav-tab1-link"
                          data-toggle="tab"
                          href="#tab1"
                          role="tab"
                          aria-controls="tab1"
                          aria-selected="true"
                        >
                        <span class="tab-sub d-block">{{$lang.messages.general}}</span>
                        </a>
                        <a
                          v-if="access_right.view_account_information"
                          class="nav-item nav-link text-center"
                          id="nav-tab9-link"
                          data-toggle="tab"
                          href="#tab9"
                          role="tab"
                          aria-controls="tab9"
                          aria-selected="true"
                        >
                          <span class="tab-sub d-block">{{$lang.messages.account_information}}</span>
                        </a>
                        <a
                          class="nav-item nav-link text-center"
                          id="nav-tab11"
                          data-toggle="tab"
                          href="#tab11"
                          role="tab"
                          aria-controls="tab11"
                          aria-selected="false"
                          v-if="access_right.access_jubelio"
                          @click="selectMainTab('JUBELIO')"
                        >
                          <span class="tab-sub d-block">{{$lang.messages.jubelio_integration}}</span>
                        </a>

                        <a
                          v-if="access_right.manage_billing"
                          class="nav-item nav-link text-center"
                          id="nav-tab10"
                          data-toggle="tab"
                          href="#tab10"
                          role="tab"
                          aria-controls="tab10"
                          aria-selected="false"
                          @click="selectMainTab('SUBSCRIPTION')"
                        >
                          <span class="tab-sub d-block">{{$lang.messages.subscription}}</span>
                        </a>
                        <a
                          v-if="access_right.set_payment_type"
                          class="nav-item nav-link"
                          id="nav-tab3"
                          data-toggle="tab"
                          href="#tab3"
                          role="tab"
                          ref="tab3"
                          aria-controls="tab3"
                          aria-selected="false"
                          @click="selectMainTab('PAYMENT_TYPE')"
                        >
                          <span class="tab-sub d-block">{{$lang.messages.payment_types}}</span>
                        </a>
                        <!-- <a
                          v-if="access_right.set_taxes"
                          class="nav-item nav-link"
                          id="nav-tab4"
                          data-toggle="tab"
                          href="#tab4"
                          role="tab"
                          aria-controls="tab4"
                          aria-selected="false"
                          @click="selectMainTab('TAXES')"
                        >
                          <span class="tab-sub d-block">{{$lang.messages.taxes}}</span>
                        </a> -->

                        <a
                          :class="access_right.edit_profile ? '' : 'active'"
                          class="nav-item nav-link"
                          id="nav-tab5"
                          data-toggle="tab"
                          href="#tab5"
                          role="tab"
                          aria-controls="tab5"
                          aria-selected="false"
                          @click="selectMainTab('RECEIPT')"
                        >
                          <span class="tab-sub d-block">{{$lang.messages.receipt}}</span>
                        </a>
                        <a
                          v-if="actualSetting.dining_options && access_right.dining_option"
                          class="nav-item nav-link"
                          id="nav-tab8"
                          data-toggle="tab"
                          href="#tab8"
                          role="tab"
                          aria-controls="tab8"
                          aria-selected="false"
                          @click="selectMainTab('DINNING_OPTIONS')"
                        >
                          <span class="tab-sub d-block">{{$lang.messages.product_delivery_option}}</span>
                        </a>
                      </div>
                    </nav>
                    <div class="tab-content px-lg-5 px-3 pb-4 pt-3" id="nav-tabContent">
                      <div
                        :class="access_right.edit_profile ? 'active' : ''"
                        class="tab-pane fade show form-style"
                        id="tab1"
                        role="tabpanel"
                        aria-labelledby="nav-tab1"
                      >
                        <form data-vv-scope="general-setting-form">
                          <h3 class="font-22 mb-4">{{$lang.messages.general_settings}}</h3>
                          <div class="row mb-lg-4 mb-0" v-if="false">
                            <div class="col-md-6 mb-3 mb-lg-0">
                              <label for>{{$lang.messages.email}}</label>
                              <input
                                name="email"
                                v-model="setting.email"
                                v-validate="'required|email'"
                                :class="{ 'form-control' : true, 'input':true, 'is-danger': errors.has('general-setting-form.email') }"
                                type="text"
                                v-bind:placeholder="$lang.messages.email"
                              />

                              <i
                                v-show="errors.has('general-setting-form.email')"
                                class="fa fa-warning"
                              ></i>
                              <span
                                v-show="errors.has('general-setting-form.email')"
                                class="help is-danger"
                              >{{$lang.messages.please_enter_email}}</span>
                            </div>
                            <div class="col-md-6">
                              <label for>{{$lang.messages.business_name}}</label>
                              <input
                                name="business_name"
                                v-model="setting.business_name"
                                v-validate="'required'"
                                :class="{ 'form-control' : true, 'input':true, 'is-danger': errors.has('general-setting-form.business_name') }"
                                type="text"
                                v-bind:placeholder="$lang.messages.business_name"
                              />

                              <i
                                v-show="errors.has('general-setting-form.business_name')"
                                class="fa fa-warning"
                              ></i>
                              <span
                                v-show="errors.has('general-setting-form.business_name')"
                                class="help is-danger"
                              >{{$lang.messages.please_enter_business_name}}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label for>{{$lang.messages.timezone}}</label>
                                <div class="custom-select-dd">
                                  <select
                                    class="form-control"
                                    v-model="setting.timezone"
                                    v-validate="'required'"
                                    name="timezone"
                                  >
                                    <option value>{{$lang.messages.select}}</option>
                                    <option
                                      v-for="timezone in timezones"
                                      :key="timezone.name"
                                      :value="timezone.id"
                                    >{{timezone.name}} ({{timezone.value}})</option>
                                  </select>

                                  <i
                                    v-show="errors.has('general-setting-form.timezone')"
                                    class="fa fa-warning"
                                  ></i>
                                  <span
                                    v-show="errors.has('general-setting-form.timezone')"
                                    class="help is-danger"
                                  >{{$lang.messages.please_select_timezone}}</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label for>{{$lang.messages.ui_language}}</label>
                                <div class="custom-select-dd">
                                  <select
                                    class="form-control"
                                    v-model="setting.ui_language"
                                    v-validate="'required'"
                                    name="ui_language"
                                  >
                                    <option value>{{$lang.messages.select}}</option>
                                    <option
                                      v-for="language in languages"
                                      :key="language.id"
                                      :value="language.id"
                                    >{{language.name}}</option>
                                  </select>
                                  <i
                                    v-show="errors.has('general-setting-form.ui_language')"
                                    class="fa fa-warning"
                                  ></i>
                                  <span
                                    v-show="errors.has('general-setting-form.ui_language')"
                                    class="help is-danger"
                                  >{{$lang.messages.please_select_ui_langugae}}</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label for>{{$lang.messages.decimal_seperator}}</label>
                                <div class="custom-select-dd">
                                  <select
                                    class="form-control"
                                    v-model="setting.decimal_separator"
                                    v-validate="'required'"
                                    name="decimal_separator"
                                  >
                                    <option value>{{$lang.messages.select}}</option>
                                    <option value="NONE">NONE</option>
                                    <option value="COMMA">COMMA</option>
                                    <option value="DOT">DOT</option>
                                  </select>

                                  <i
                                    v-show="errors.has('general-setting-form.decimal_separator')"
                                    class="fa fa-warning"
                                  ></i>
                                  <span
                                    v-show="errors.has('general-setting-form.decimal_separator')"
                                    class="help is-danger"
                                  >{{$lang.messages.please_select_decimal_separator}}</span>
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-12 mb-3">
                              <hr />
                            </div>
                          </div>

                          <h3 class="font-22 mb-4">{{$lang.messages.features}}</h3>
                          <div class="row">
                            <div class="col-md-9">
                              <p class="mb-0">Shifts</p>
                              <p class="font-14 text-grey">
                                {{$lang.messages.track_crash_that_goes_in_and_out_of_your_drawer}}
                                <!-- <a
                                  href
                                  class="text-info"
                                  target="_blank"
                                >{{$lang.messages.learn_more}}</a>-->
                              </p>
                            </div>
                            <div class="col-md-3 text-md-right align-self-center">
                              <div class="form-group">
                                <span class="switch switch-sm">
                                  <input
                                    type="checkbox"
                                    v-model="setting.shifts"
                                    id="switch-1"
                                    class="switch"
                                  />

                                  <label for="switch-1"></label>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-9">
                              <p class="mb-0">{{$lang.messages.time_clock}}</p>
                              <p class="font-14 text-grey">
                                {{$lang.messages.track_employees_clock_in_out_time_and_calculate_their_total_work_hours}}
                                <!-- <a
                                  href
                                  class="text-info"
                                  target="_blank"
                                >{{$lang.messages.learn_more}}</a>-->
                              </p>
                            </div>
                            <div class="col-md-3 text-md-right align-self-center">
                              <div class="form-group">
                                <span class="switch switch-sm">
                                  <input
                                    type="checkbox"
                                    class="switch"
                                    id="switch-2"
                                    v-model="setting.time_clock"
                                    @click="check()"
                                  />
                                  <label for="switch-2"></label>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-9">
                              <p class="mb-0">{{$lang.messages.dinning_options}}</p>
                              <p class="font-14 text-grey">
                                {{$lang.messages.mark_orders_as_dine_in_takeout_or_for_delivery}}
                                <!-- <a
                                  href
                                  class="text-info"
                                  target="_blank"
                                >{{$lang.messages.learn_more}}</a>-->
                              </p>
                            </div>
                            <div class="col-md-3 text-md-right align-self-center">
                              <div class="form-group">
                                <span class="switch switch-sm">
                                  <input
                                    type="checkbox"
                                    class="switch"
                                    id="switch-6"
                                    v-model="setting.dining_options"
                                  />
                                  <label for="switch-6"></label>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-9">
                              <p class="mb-0">{{$lang.messages.online_storefront}}</p>
                              <p class="font-14 text-grey">
                                {{$lang.messages.online_storefront_desc}}
                                <!-- <a
                                  href
                                  class="text-info"
                                  target="_blank"
                                >{{$lang.messages.learn_more}}</a>-->
                              </p>
                            </div>
                            <div class="col-md-3 text-md-right align-self-center">
                              <div class="form-group">
                                <span class="switch switch-sm">
                                  <input
                                    type="checkbox"
                                    class="switch"
                                    id="switch-20"
                                    v-model="setting.storefront"
                                    @click="checkMenuApp()"
                                  />
                                  <label for="switch-20"></label>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-9">
                              <p class="mb-0">{{$lang.messages.enable_b2b}}</p>
                              <p class="font-14 text-grey">
                                {{$lang.messages.enable_b2b_desc}}
                              </p>
                            </div>
                            <div class="col-md-3 text-md-right align-self-center">
                              <div class="form-group">
                                <span class="switch switch-sm">
                                  <input
                                    type="checkbox"
                                    class="switch"
                                    id="switch-12"
                                    v-model="setting.is_enable_b2b"
                                  />
                                  <label for="switch-12"></label>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="setting.is_menu_app">
                            <div class="col-md-9">
                              <p class="mb-0">{{$lang.messages.menu_app}}</p>
                              <p class="font-14 text-grey">
                                {{$lang.messages.employees_can_log_in_to_the_menu_app_using_their_email_and_password}}
                                <!-- <a
                                  href
                                  class="text-info"
                                  target="_blank"
                                >{{$lang.messages.learn_more}}</a>-->
                              </p>
                            </div>
                            <div class="col-md-3 text-md-right align-self-center">
                              <div class="form-group">
                                <span class="switch switch-sm">
                                  <input
                                    type="checkbox"
                                    class="switch"
                                    id="switch-10"
                                    v-model="setting.menu_app"
                                    @click="checkMenuApp()"
                                  />
                                  <label for="switch-10"></label>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-9">
                              <p class="mb-0">{{$lang.messages.customer_sharing}}</p>
                              <p class="font-14 text-grey">
                                {{$lang.messages.customer_sharing_desc}}
                                <!-- <a
                                  href
                                  class="text-info"
                                  target="_blank"
                                >{{$lang.messages.learn_more}}</a>-->
                              </p>
                            </div>
                            <div class="col-md-3 text-md-right align-self-center">
                              <div class="form-group">
                                <span class="switch switch-sm">
                                  <input
                                    type="checkbox"
                                    class="switch"
                                    id="switch-11"
                                    v-model="setting.customer_sharing"
                                    @click="checkMenuApp()"
                                  />
                                  <label for="switch-11"></label>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-lg-12 text-right">
                              <button
                                id="general-save-btn"
                                type="button"
                                class="btn btn-primary"
                                @click="validateForm('general-setting-form')"
                              >{{$lang.messages.save_btn_text}}</button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div
                        class="tab-pane fade"
                        id="tab10"
                        role="tabpanel"
                        aria-labelledby="nav-tab10">

                        <div class="table-responsive">
                          <table class="table table-striped table-style-1">
                            <thead>
                              <tr>
                                <th scope="col">Sr.no</th>
                                <th scope="col">{{$lang.messages.name}}</th>
                                <th scope="col">{{$lang.messages.period}}</th>
                                <th scope="col">{{$lang.messages.price}}</th>
                                <th scope="col">{{$lang.messages.end_date}}</th>
                                <th scope="col" class="text-center">{{$lang.messages.action}}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(subscription,i) in subscription_list"
                                :key="subscription.id"
                              >
                                <td>{{ i +1}}</td>
                                <td>{{subscription.name}}</td>
                                <td>{{subscription.period}}</td>
                                <td>{{subscription.amount}}</td>
                                <td>{{subscription.end_date ? subscription.end_date : '-'}}</td>
                                <td class="text-center">
                                  <button
                                    v-if="!subscription.is_activate"
                                    type="button"
                                    class="btn btn-primary"
                                    @click="showSubscriptionAlert('SUBSCRIBE', subscription)"
                                  >{{$lang.messages.subscribe}}</button>
                                  <button
                                    v-else
                                    type="button"
                                    class="btn btn-outline-primary"
                                    @click="showSubscriptionAlert('UNSUBSCRIBE', subscription)"
                                  >{{$lang.messages.unsubscribe}}</button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <ErrorComponent
                            @retry="subscriptionRetry()"
                            ref="subscriptionErrorComonent"
                          />
                        </div>
                      </div>
                      <div
                        class="tab-pane fade"
                        id="tab11"
                        role="tabpanel"
                        aria-labelledby="nav-tab11">
                        <div v-if="is_owner">
                          <form data-vv-scope="jubelio-login-form" v-if="!!!jubelio.id || jubelio.status == 'INACTIVE'">
                            <h3 class="font-22 mb-4">{{$lang.messages.connect_to_jubelio_account}}</h3>
                            <div class="row mb-lg-4 mb-0">
                              <div class="col-md-6 mb-3 mb-lg-0">
                                <label for>{{$lang.messages.email}}</label>
                                <input
                                  name="jubelio-email"
                                  v-model="jubelio.email"
                                  v-validate="'required|email'"
                                  :class="{ 'form-control' : true, 'input':true, 'is-danger': errors.has('jubelio-login-form.email') }"
                                  type="text"
                                  v-bind:placeholder="$lang.messages.email"
                                />
                                <i
                                  v-show="errors.has('jubelio-login-form.email')"
                                  class="fa fa-warning"
                                ></i>
                                <span
                                  v-show="errors.has('jubelio-login-form.email')"
                                  class="help is-danger"
                                >{{$lang.messages.please_enter_email}}</span>
                              </div>
                            </div>
                            <div class="row mb-lg-4 mb-0">
                              <div class="col-md-6">
                                <label for>{{$lang.messages.password}}</label>
                                <input
                                  name="jubelio-password"
                                  v-model="jubelio.password"
                                  v-validate="'required'"
                                  :class="{ 'form-control' : true, 'input':true, 'is-danger': errors.has('jubelio-login-form.password') }"
                                  type="password"
                                  v-bind:placeholder="$lang.messages.password"
                                />

                                <i
                                  v-show="errors.has('jubelio-login-form.password')"
                                  class="fa fa-warning"
                                ></i>
                                <span
                                  v-show="errors.has('jubelio-login-form.password')"
                                  class="help is-danger"
                                >{{$lang.messages.please_enter_business_name}}</span>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-lg-12">
                                <button
                                  type="button"
                                  id="jubelio-login-btn"
                                  class="btn btn-primary mr-3"
                                  @click="validateForm('jubelio-login-form')"
                                >{{$lang.messages.login}}</button>
                              </div>
                            </div>
                          </form>
                          <div v-else>
                            <div class="row">
                              <div class="col-lg-4 col-6 text-left">
                                <h3 class="font-22 mb-4">{{$lang.messages.jubelio_account}}</h3>
                              </div>
                              <div class="col-lg-8 col-6 text-right">
                                <button @click="logoutJubelio()" class="btn btn-danger px-4">{{$lang.messages.logout}}</button>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-12 text-left">
                                <div>Email: {{ jubelio.email }}</div>
                              </div>
                            </div>

                            <div class="row mt-4">
                              <div class="col-12 text-left">
                                <div>{{$lang.messages.active_company}}: {{ jubelio.company_name }}</div>
                              </div>
                            </div>

                            <div class="row mt-4">
                              <div class="col-lg-4 col-md-6 col-12 text-left">
                                <div>{{$lang.messages.default_so_salesman}}: </div>
                              </div>
                              <div class="col-lg-8 col-md-6 col-12 text-left">
                                <div class="w-xs-100" style="width: 300px;">
                                  <select
                                    v-model="jubelio.default_salesmen_id"
                                    class="form-control">
                                    <option
                                      v-for="contact in jubelioContacts"
                                      :key="contact.contact_id"
                                      :value="contact.contact_id"
                                    >{{contact.contact_full}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div class="row mt-4">
                              <div class="col-lg-4 col-md-6 col-12 text-left">
                                <div class="mb-2">{{$lang.messages.default_po_salesman}}: </div>
                              </div>
                              <div class="col-lg-8 col-md-6 col-12 text-right">
                                <div class="w-xs-100 w-md-100" style="width: 300px;">
                                <select
                                  v-model="jubelio.default_po_salesmen_id"
                                  class="form-control">
                                  <option
                                    v-for="contact in jubelioContacts"
                                    :key="contact.contact_id"
                                    :value="contact.contact_id"
                                  >{{contact.contact_full}}</option>
                                </select>
                                </div>
                              </div>
                            </div>

                            <div class="row mt-4">
                              <div class="col-lg-4 col-md-6 col-12 text-left">
                                <div class="mb-2">{{$lang.messages.default_location}}: </div>
                              </div>
                              <div class="col-lg-8 col-md-6 col-12 text-right">
                                <div class="w-xs-100" style="width: 300px;">
                                <select
                                  v-model="jubelio.default_location_id"
                                  class="form-control">
                                  <option
                                    v-for="location in jubelioLocations"
                                    :key="location.location_id"
                                    :value="location.location_id"
                                  >{{location.location_name}}</option>
                                </select>
                                </div>
                              </div>
                            </div>

                            <div class="mb-3 mt-5">
                              <div class="row mb-3 mt-2">
                                <div class="col-lg-9 col-md-10 col-6">
                                  <div class="mb-0">{{$lang.messages.sync_all_sales_to_jubelio}}</div>
                                  <p class="mb-1 mt-1" style="color: #515464; font-size: 14px">{{$lang.messages.for_stores_that_not_enabled_b2b_buying}}</p>
                                  <p class="mb-0" style="color: #515464; font-size: 14px">{{$lang.messages.for_stores_that_enabled_b2b_buying}}</p>
                                  <p v-if="jubelio.status == 'EXPIRED'" class="font-14 text-danger">
                                    {{$lang.messages.unable_to_synchronize_to_jubelio}}
                                  </p>
                                </div>
                                <div class="col-lg-3 col-md-12 col-6 text-right">
                                  <div class="form-group">
                                    <span class="switch switch-sm">
                                      <input
                                        type="checkbox"
                                        class="switch"
                                        id="jubelio_is_enable"
                                        v-model="jubelio.is_enable"/>
                                      <label for="jubelio_is_enable"></label>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-12 text-right">
                                <button type="button" class="btn btn-primary" @click="jubelioUpdate()">{{$lang.messages.save}}</button>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12 mb-3">
                            <hr />
                          </div>
                        </div>

                        <!-- Add item from jubelio section-->
                        <div v-if="!!jubelio.token &&  (is_owner || access_right.access_jubelio)">
                          <div class="mb-3 text-center">
                            <h3>{{$lang.messages.add_item_to_jubelio}}</h3>
                          </div>
                          <div class="mb-3 text-left">
                            <span class="pr-3">{{$lang.messages.filter_by}}:</span>
                            <div class="custom-control custom-radio d-inline-block mr-5">
                              <input
                                type="radio"
                                class="custom-control-input"
                                id="filterItem"
                                :checked="jubelio_item_type == 'ITEM'"
                                name="radio-stacked"
                                @click="setJubelioItemType('ITEM')"
                              />
                              <label
                                class="custom-control-label"
                                for="filterItem"
                              >{{$lang.messages.item}}</label>
                            </div>

                            <div class="custom-control custom-radio d-inline-block mr-5">
                              <input
                                type="radio"
                                class="custom-control-input"
                                id="filterItemBundle"
                                :checked="jubelio_item_type == 'ITEM_BUNDLE'"
                                name="radio-stacked"
                                @click="setJubelioItemType('ITEM_BUNDLE')"
                              />
                              <label
                                class="custom-control-label"
                                for="filterItemBundle"
                              >{{$lang.messages.item_bundle}}</label>
                            </div>
                          </div>
                          <div class="mb-3 text-center">
                            <form @submit.prevent="jubelioInventoryItem(1)">
                              <div class="input-group input-group-lg">
                              <input
                                type="text"
                                class="form-control input-lg"
                                v-model="query"
                                :placeholder="$lang.messages.search_product_name_or_sku"/>
                                <span class="input-group-append">
                                  <button class="btn btn-outline-secondary" type="submit" style="background-color:#3c2781">
                                      <i class="fa fa-search" style="color: white"></i>
                                  </button>
                                </span>
                              </div>
                            </form>
                          </div>
                          <div class="table-responsive">
                          <table class="table table-striped table-style-1">
                            <thead>
                              <tr>
                                <th scope="col">{{$lang.messages.product_name}}</th>
                                <th scope="col">SKU</th>
                                <th scope="col">{{$lang.messages.add_item}}</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(item, index) in this.jubelioItemsData.objects"
                                :key="index">
                                <td>{{item.name}}</td>
                                <td>{{item.sku}}</td>
                                <td>
                                  <div v-if="!!item.pos_item_id || !!item.pos_item_variant_combine_id">{{$lang.messages.item_added}}</div>
                                  <div v-else-if="item.is_existed_sku">{{$lang.messages.existed_sku}}</div>
                                  <button v-else
                                    type="button"
                                    class="btn btn-primary"
                                    @click="jubelioSyncItem(item)"
                                  >{{$lang.messages.add_item}}</button>
                                </td>
                                <td>
                                  <div v-if="!!item.pos_item_id || !!item.pos_item_variant_combine_id">
                                    <button
                                    type="button"
                                    class="btn btn-primary"
                                    @click="jubelioSyncItem(item)"
                                  >{{$lang.messages.update}}</button></div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          </div>
                          <div class="page-bottom-pagination text-right" v-if="!(!!!jubelio.id || jubelio.status == 'INACTIVE')">
                            <Pagination
                              @page-change="pageChange"
                              @items-per-page-change="itemsPerPageChange()"
                              ref="listPagination"
                            />
                          </div>
                        </div>
                        <div v-else>
                          <h5 v-if="!!!jubelio.token && !is_owner">{{$lang.messages.the_owner_must_signin_to_the_jubelio}}</h5>
                          <h5 v-if="!!jubelio.token && !is_owner">{{$lang.messages.you_do_not_have_access_to_menu}}</h5>
                        </div>
                      </div>

                      <div
                        v-if="access_right.view_account_information"
                        class="tab-pane fade show form-style"
                        id="tab9"
                        role="tabpanel"
                        aria-labelledby="nav-tab9"
                      >
                        <h1 style class="mt-lg-4">{{$lang.messages.business_information}}</h1>
                        <hr />
                        <form data-vv-scope="business_form">
                          <div class="col-md-12 form-group">
                            <label>{{ $lang.messages.workspace }}</label>
                            <input type="text" name="workspace" class="form-control" disabled :value="client.business_info.workspace">
                          </div>

                          <div class="col-md-12">
                            <div class="row mb-lg-4 mb-0">
                              <div class="col-lg-6 mb-md-4 mb-3">
                                <label>{{$lang.messages.business_entity_type}}</label>
                                <span style="color:#ff0000">*</span>
                                <div class="text-right custom-select-dd">
                                  <select
                                    v-model="client.business_info.business_entity_type"
                                    :disabled="!access_right.edit_account_information"
                                    name="business_entity_type"
                                    v-validate="'required'"
                                    class="form-control"
                                    :class="{'input':true, 'is-danger': errors.has('business_form.business_entity_type') }"
                                  >
                                    <option value>{{$lang.messages.business_type}}</option>
                                    <option value="PERSONAL">{{$lang.messages.personal}}</option>
                                    <option value="CORPORATE">{{$lang.messages.corporate}}</option>
                                  </select>
                                  <i
                                    v-show="errors.has('business_form.business_entity_type')"
                                    class="fa fa-warning"
                                  ></i>
                                  <span
                                    v-show="errors.has('business_form.business_entity_type')"
                                    class="help is-danger"
                                  >Please select business type</span>
                                </div>
                              </div>
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.business_type}}</label>
                                <span style="color:#ff0000">*</span>
                                <div class="text-right custom-select-dd">
                                  <select
                                    v-model="client.business_info.business_type_id"
                                    :disabled="!access_right.edit_account_information"
                                    name="business_type_id"
                                    class="form-control"
                                    v-validate="'required'"
                                    :class="{'input':true, 'is-danger': errors.has('business_form.business_type_id') }"
                                    @change="getSubBusinessType(true)"
                                  >
                                    <option value>{{$lang.messages.select_business_type}}</option>
                                    <option
                                      v-for="business in businessList"
                                      :key="business.id"
                                      :value="business.id"
                                    >{{business.name}}</option>
                                  </select>
                                  <i
                                    v-show="errors.has('business_form.business_type_id')"
                                    class="fa fa-warning"
                                  ></i>
                                  <span
                                    v-show="errors.has('business_form.business_type_id')"
                                    class="help is-danger"
                                  >Please select business type</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row mb-lg-4">
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.sub_business_type}}</label>
                                <span style="color:#ff0000">*</span>
                                <div class="text-right custom-select-dd">
                                  <select
                                    v-model="client.business_info.sub_business_type_id"
                                    :disabled="!access_right.edit_account_information"
                                    name="sub_business_type_id"
                                    v-validate="'required'"
                                    class="form-control"
                                    :class="{'input':true, 'is-danger': errors.has('business_form.sub_business_type_id') }"
                                  >
                                    <option value>{{$lang.messages.select_sub_business_type}}</option>
                                    <option
                                      v-for="sub_business in subbusinessList"
                                      :key="sub_business.id"
                                      :value="sub_business.id"
                                    >{{sub_business.name}}</option>
                                  </select>
                                  <i
                                    v-show="errors.has('business_form.sub_business_type_id')"
                                    class="fa fa-warning"
                                  ></i>
                                  <span
                                    v-show="errors.has('business_form.sub_business_type_id')"
                                    class="help is-danger"
                                  >Please select sub business type</span>
                                </div>
                              </div>
                              <div class="col-lg-6 mb-4">
                                <label for>{{$lang.messages.business_name}}</label>
                                <span style="color:#ff0000">*</span>
                                <input
                                  name="business_info_business_name"
                                  v-model="client.business_info.business_name"
                                  :disabled="!access_right.edit_account_information"
                                  v-validate="'required'"
                                  class="form-control"
                                  :class="{'input':true, 'is-danger': errors.has('business_form.business_info_business_name') }"
                                  type="text"
                                  v-bind:placeholder="$lang.messages.name"
                                />
                                <i
                                  v-show="errors.has('business_form.business_info_business_name')"
                                  class="fa fa-warning"
                                ></i>
                                <span
                                  v-show="errors.has('business_form.business_info_business_name')"
                                  class="help is-danger"
                                >Please enter business name</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row mb-lg-4">
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.email}}</label>
                                <input
                                  name="business_info_email"
                                  v-model="client.business_info.email"
                                  :disabled="!access_right.edit_account_information"
                                  v-validate="'email'"
                                  class="form-control"
                                  :class="{'input':true, 'is-danger': errors.has('business_form.business_info_email') }"
                                  type="text"
                                  v-bind:placeholder="$lang.messages.email"
                                />
                                <i
                                  v-show="errors.has('business_form.business_info_email')"
                                  class="fa fa-warning"
                                ></i>
                                <span
                                  v-show="errors.has('business_form.business_info_email')"
                                  class="help is-danger"
                                >{{$lang.messages.please_enter_email}}</span>
                              </div>
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.phone_number}}</label>
                                <input
                                  name="business_info_phone_number"
                                  v-model="client.business_info.phone_number"
                                  :disabled="!access_right.edit_account_information"
                                  v-validate="'numeric'"
                                  class="form-control"
                                  :class="{'input':true, 'is-danger': errors.has('business_form.business_info_phone_number') }"
                                  type="text"
                                  v-bind:placeholder="$lang.messages.phone_number"
                                />
                                <i
                                  v-show="errors.has('business_form.business_info_phone_number')"
                                  class="fa fa-warning"
                                ></i>
                                <span
                                  v-show="errors.has('business_form.business_info_phone_number')"
                                  class="help is-danger"
                                >{{$lang.messages.please_enter_phone_number}}</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row mb-lg-4">
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.mobile_number}}</label>
                                <div class="input-group mb-3">
                                  <div class="input-group-prepend">
                                    <label class="input-group-text">{{ country_code }}</label>
                                  </div>
                                  <input
                                  name="business_info_mobile_number"
                                  v-model="client.business_info.mobile_number"
                                  :disabled="!access_right.edit_account_information"
                                  v-validate="'numeric|min:7'"
                                  class="form-control"
                                  :class="{'input':true, 'is-danger': errors.has('business_form.business_info_mobile_number') }"
                                  type="text"
                                  v-bind:placeholder="$lang.messages.mobile_number"
                                />
                                <i
                                  v-show="errors.has('business_form.business_info_mobile_number')"
                                  class="fa fa-warning"
                                ></i>
                                <span
                                  v-show="errors.has('business_form.business_info_mobile_number')"
                                  class="help is-danger"
                                >{{$lang.messages.please_enter_mobile_number}}</span>
                                </div>
                              </div>
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.province}}</label>
                                <span style="color:#ff0000">*</span>
                                <div class="text-right custom-select-dd">
                                  <select
                                    v-model="client.business_info.state_id"
                                    :disabled="!access_right.edit_account_information"
                                    name="state_id"
                                    class="form-control"
                                    v-validate="'required'"
                                    :class="{'input':true, 'is-danger': errors.has('business_form.state_id') }"
                                    @change="getDistrictList(client.business_info.state_id, true, 'BUSINESS')"
                                  >
                                    <option value disabled selected>{{$lang.messages.select_province}}</option>
                                    <option
                                      v-for="state in stateList"
                                      :key="state.id"
                                      :value="state.id"
                                    >{{state.name}}</option>
                                  </select>
                                  <i
                                    v-show="errors.has('business_form.state_id')"
                                    class="fa fa-warning"
                                  ></i>
                                  <span
                                    v-show="errors.has('business_form.state_id')"
                                    class="help is-danger"
                                  >{{$lang.messages.please_select_state}}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row mb-lg-4">
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.city}}</label>
                                <span style="color:#ff0000">*</span>
                                <div class="text-right custom-select-dd">
                                  <select
                                    v-model="client.business_info.district_id"
                                    :disabled="!access_right.edit_account_information"
                                    name="district_id"
                                    class="form-control"
                                    v-validate="'required'"
                                    :class="{'input':true, 'is-danger': errors.has('business_form.district_id') }"
                                    @change="getCityList(client.business_info.district_id, true, 'BUSINESS')"
                                  >
                                    <option value disabled selected>{{$lang.messages.select_city}}</option>
                                    <option
                                      v-for="district in districtList"
                                      :key="district.id"
                                      :value="district.id"
                                    >{{district.name}}</option>
                                  </select>
                                  <i
                                    v-show="errors.has('business_form.district_id')"
                                    class="fa fa-warning"
                                  ></i>
                                  <span
                                    v-show="errors.has('business_form.district_id')"
                                    class="help is-danger"
                                  >{{$lang.messages.please_select_city}}</span>
                                </div>
                              </div>
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.district}}</label>
                                <span style="color:#ff0000">*</span>
                                <div class="text-right custom-select-dd">
                                  <select
                                    v-model="client.business_info.city_id"
                                    :disabled="!access_right.edit_account_information"
                                    name="city_id"
                                    class="form-control"
                                    v-validate="'required'"
                                    :class="{'input':true, 'is-danger': errors.has('business_form.city_id') }"
                                  >
                                    <option value disabled selected>{{$lang.messages.select_district}}</option>
                                    <option
                                      v-for="city in cityList"
                                      :key="city.id"
                                      :value="city.id"
                                    >{{city.name}}</option>
                                  </select>
                                  <i
                                    v-show="errors.has('business_form.city_id')"
                                    class="fa fa-warning"
                                  ></i>
                                  <span
                                    v-show="errors.has('business_form.city_id')"
                                    class="help is-danger"
                                  >{{$lang.messages.please_select_district}}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row mb-lg-4">
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.postal_or_zip_code}}</label>
                                <input
                                  name="zip_code"
                                  v-model="client.business_info.postal_code"
                                  :disabled="!access_right.edit_account_information"
                                  class="form-control"
                                  :class="{'input':true, 'is-danger': errors.has('business_form.zip_code') }"
                                  type="text"
                                  v-bind:placeholder="$lang.messages.postal_or_zip_code"
                                />
                                <i
                                  v-show="errors.has('business_form.zip_code')"
                                  class="fa fa-warning"
                                ></i>
                                <span
                                  v-show="errors.has('business_form.zip_code')"
                                  class="help is-danger"
                                >{{$lang.messages.please_enter_zip_code}}</span>
                              </div>
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.address}}</label>
                                <span style="color:#ff0000">*</span>
                                <textarea
                                  name="address"
                                  v-model="client.business_info.address"
                                  :disabled="!access_right.edit_account_information"
                                  v-validate="'required'"
                                  class="form-control"
                                  rows="2"
                                  style="height: auto"
                                  :class="{'input':true, 'is-danger': errors.has('business_form.address') }"
                                  type="text"
                                  v-bind:placeholder="$lang.messages.address"
                                />
                                <i
                                  v-show="errors.has('business_form.address')"
                                  class="fa fa-warning"
                                ></i>
                                <span
                                  v-show="errors.has('business_form.address')"
                                  class="help is-danger"
                                >{{$lang.messages.please_enter_address}}</span>
                              </div>
                            </div>
                          </div>
                          <h1
                            style="margin-top:30px;"
                            v-if="access_right.edit_account_information"
                          >{{$lang.messages.personal_information}}</h1>
                          <h1 style="margin-top:30px;" v-else>Owner Information</h1>
                          <hr />
                          <div class="col-md-12">
                            <div class="row mb-lg-4">
                              <div class="col-lg-6 mb-4">
                                <label for>{{$lang.messages.id_card_number}}</label>
                                <span style="color:#ff0000">*</span>
                                <input
                                  name="person_info_id_card_number"
                                  v-model="client.person_info.id_card_number"
                                  :disabled="!access_right.edit_account_information"
                                  v-validate="'required'"
                                  class="form-control"
                                  :class="{'input':true, 'is-danger': errors.has('business_form.person_info_id_card_number') }"
                                  type="text"
                                  placeholder="KTP card number"
                                />
                                <i
                                  v-show="errors.has('business_form.person_info_id_card_number')"
                                  class="fa fa-warning"
                                ></i>
                                <span
                                  v-show="errors.has('business_form.person_info_id_card_number')"
                                  class="help is-danger"
                                >Please enter card number</span>
                              </div>
                              <div class="col-lg-6 mb-4">
                                <label for>{{$lang.messages.name_on_id_card}}</label>
                                <span style="color:#ff0000">*</span>
                                <input
                                  name="person_info_id_card_name"
                                  v-model="client.person_info.id_card_name"
                                  :disabled="!access_right.edit_account_information"
                                  v-validate="'required'"
                                  class="form-control"
                                  :class="{'input':true, 'is-danger': errors.has('business_form.person_info_id_card_name') }"
                                  type="text"
                                  placeholder="Card name"
                                />
                                <i
                                  v-show="errors.has('business_form.person_info_id_card_name')"
                                  class="fa fa-warning"
                                ></i>
                                <span
                                  v-show="errors.has('business_form.person_info_id_card_name')"
                                  class="help is-danger"
                                >Please enter name</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row mb-lg-4">
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.email}}</label>
                                <input
                                  name="person_info_email"
                                  v-model="client.person_info.email"
                                  v-validate="'email'"
                                  class="form-control"
                                  :class="{'input':true, 'is-danger': errors.has('business_form.person_info_email') }"
                                  type="text"
                                  v-bind:placeholder="$lang.messages.email"
                                />
                                <i
                                  v-show="errors.has('business_form.person_info_email')"
                                  class="fa fa-warning"
                                ></i>
                                <span
                                  v-show="errors.has('business_form.person_info_email')"
                                  class="help is-danger"
                                >{{$lang.messages.please_enter_email}}</span>
                              </div>

                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.mobile_number}}</label>
                                <div class="input-group mb-3">
                                  <div class="input-group-prepend">
                                    <label class="input-group-text">{{ country_code }}</label>
                                  </div>
                                  <input
                                      name="person_info_phone_number"
                                      v-model="client.person_info.phone_number"
                                      v-validate="'numeric|min: 7'"
                                      class="form-control"
                                      disabled
                                      :class="{'input':true, 'is-danger': errors.has('business_form.person_info_phone_number') }"
                                      type="text"
                                      v-bind:placeholder="$lang.messages.phone_number"
                                  />
                                  <i
                                      v-show="errors.has('business_form.person_info_phone_number')"
                                      class="fa fa-warning"
                                  ></i>
                                  <span
                                      v-show="errors.has('business_form.person_info_phone_number')"
                                      class="help is-danger"
                                  >{{ $lang.messages.please_enter_phone_number }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row mb-4">
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.date_of_birth}}</label>
                                <span style="color:#ff0000">*</span>
                                <br />
                                <date-picker
                                  v-model="client.person_info.date_of_birth"
                                  :disabled="!access_right.edit_account_information"
                                  style="width:100%;"
                                  format="DD-MM-YYYY"
                                  :class="{'input':true, 'is-danger': errors.has('date_of_birth') }"
                                  lang="en"
                                  name="business_form.date_of_birth"
                                  v-validate="'required'"
                                  :close-on-content-click="false"
                                ></date-picker>
                                <br />
                                <i
                                  v-show="errors.has('business_form.date_of_birth')"
                                  class="fa fa-warning"
                                ></i>
                                <span
                                  v-show="errors.has('business_form.date_of_birth')"
                                  class="help is-danger"
                                >Please enter date of birth</span>
                              </div>
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.gender}}</label>
                                <span style="color:#ff0000">*</span>
                                <br />
                                <div class="custom-control custom-radio d-inline-block mr-5">
                                  <input
                                    type="radio"
                                    class="custom-control-input"
                                    id="customControlValidation3"
                                    name="radio-stacked"
                                    v-model="client.person_info.gender"
                                    :disabled="!access_right.edit_account_information"
                                    value="MALE"
                                    required
                                  />
                                  <label
                                    class="custom-control-label"
                                    for="customControlValidation3"
                                  >{{$lang.messages.male}}</label>
                                </div>
                                <div class="custom-control custom-radio d-inline-block">
                                  <input
                                    type="radio"
                                    class="custom-control-input"
                                    id="customControlValidation2"
                                    name="radio-stacked"
                                    v-model="client.person_info.gender"
                                    :disabled="!access_right.edit_account_information"
                                    value="FEMALE"
                                    required
                                  />
                                  <label
                                    class="custom-control-label"
                                    for="customControlValidation2"
                                  >{{$lang.messages.female}}</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row mb-lg-4">
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.address}}</label>
                                <span style="color:#ff0000">*</span>
                                <textarea
                                  name="home_address"
                                  v-model="client.person_info.home_address"
                                  :disabled="!access_right.edit_account_information"
                                  class="form-control"
                                  v-validate="'required'"
                                  rows="2"
                                  style="height: auto"
                                  :class="{'input':true, 'is-danger': errors.has('business_form.home_address') }"
                                  type="text"
                                  v-bind:placeholder="$lang.messages.address_2"
                                />
                                <i
                                  v-show="errors.has('business_form.home_address')"
                                  class="fa fa-warning"
                                ></i>
                                <span
                                  v-show="errors.has('business_form.home_address')"
                                  class="help is-danger"
                                >Please enter address</span>
                              </div>
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.province}}</label>
                                <span style="color:#ff0000">*</span>
                                <div class="text-right custom-select-dd">
                                  <select
                                    v-model="client.person_info.state_id"
                                    :disabled="!access_right.edit_account_information"
                                    name="person_state_id"
                                    class="form-control"
                                    v-validate="'required'"
                                    :class="{'input':true, 'is-danger': errors.has('business_form.person_state_id') }"
                                    @change="getDistrictList(client.person_info.state_id, true, 'PERSON')"
                                  >
                                    <option value disabled selected>{{$lang.messages.select_province}}</option>
                                    <option
                                      v-for="state in personstateList"
                                      :key="state.id"
                                      :value="state.id"
                                    >{{state.name}}</option>
                                  </select>
                                  <i
                                    v-show="errors.has('business_form.person_state_id')"
                                    class="fa fa-warning"
                                  ></i>
                                  <span
                                    v-show="errors.has('business_form.person_state_id')"
                                    class="help is-danger"
                                  >{{$lang.messages.please_select_state}}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row mb-lg-4">
                              <div class="col-lg-6 mb-4">
                                <label for>{{$lang.messages.city}}</label>
                                <span style="color:#ff0000">*</span>
                                <div class="text-right custom-select-dd">
                                  <select
                                    v-model="client.person_info.district_id"
                                    :disabled="!access_right.edit_account_information"
                                    name="person_district_id"
                                    class="form-control"
                                    v-validate="'required'"
                                    :class="{'input':true, 'is-danger': errors.has('business_form.person_district_id') }"
                                    @change="getCityList(client.person_info.district_id, true, 'PERSON')"
                                  >
                                    <option value disabled selected>{{$lang.messages.select_city}}</option>
                                    <option
                                      v-for="district in persondistrictList"
                                      :key="district.id"
                                      :value="district.id"
                                    >{{district.name}}</option>
                                  </select>
                                  <i
                                    v-show="errors.has('business_form.person_district_id')"
                                    class="fa fa-warning"
                                  ></i>
                                  <span
                                    v-show="errors.has('business_form.person_district_id')"
                                    class="help is-danger"
                                  >{{$lang.messages.please_select_city}}</span>
                                </div>
                              </div>
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.district}}</label>
                                <span style="color:#ff0000">*</span>
                                <div class="text-right custom-select-dd">
                                  <select
                                    v-model="client.person_info.city_id"
                                    :disabled="!access_right.edit_account_information"
                                    name="person_city_id"
                                    class="form-control"
                                    v-validate="'required'"
                                    :class="{'input':true, 'is-danger': errors.has('business_form.person_city_id') }"
                                    @change="getVillageList(client.person_info.city_id, true)"
                                  >
                                    <option value disabled selected>{{$lang.messages.select_district}}</option>
                                    <option
                                      v-for="city in personcityList"
                                      :key="city.id"
                                      :value="city.id"
                                    >{{city.name}}</option>
                                  </select>
                                  <i
                                    v-show="errors.has('business_form.person_city_id')"
                                    class="fa fa-warning"
                                  ></i>
                                  <span
                                    v-show="errors.has('business_form.person_city_id')"
                                    class="help is-danger"
                                  >{{$lang.messages.please_select_district}}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row mb-lg-4">
                              <div class="col-lg-6 mb-4">
                                <label for>{{$lang.messages.village}}</label>
                                <span style="color:#ff0000">*</span>
                                <div class="text-right custom-select-dd">
                                  <select
                                    v-model="client.person_info.village_id"
                                    :disabled="!access_right.edit_account_information"
                                    name="village_id"
                                    class="form-control"
                                    v-validate="'required'"
                                    :class="{'input':true, 'is-danger': errors.has('business_form.village_id') }"
                                  >
                                    <option value disabled selected>{{$lang.messages.select_village}}</option>
                                    <option
                                      v-for="village in villageList"
                                      :key="village.id"
                                      :value="village.id"
                                    >{{village.name}}</option>
                                  </select>
                                  <i
                                    v-show="errors.has('business_form.village_id')"
                                    class="fa fa-warning"
                                  ></i>
                                  <span
                                    v-show="errors.has('business_form.village_id')"
                                    class="help is-danger"
                                  >{{$lang.messages.please_select_village}}</span>
                                </div>
                              </div>
                              <div class="col-lg-6 mb-4">
                                <label>RT</label>
                                <input
                                  name="rt"
                                  v-model="client.person_info.RT"
                                  :disabled="!access_right.edit_account_information"
                                  class="form-control"
                                  type="text"
                                  placeholder="RT"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row mb-lg-4">
                              <div class="col-lg-6 mb-4">
                                <label>RW</label>
                                <input
                                  name="rw"
                                  v-model="client.person_info.RW"
                                  :disabled="!access_right.edit_account_information"
                                  class="form-control"
                                  type="text"
                                  placeholder="RW"
                                />
                              </div>
                              <div class="col-lg-6 mb-4">
                                <!-- <h1>hii</h1> -->
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row mb-lg-4">
                              <div class="col-lg-6 mb-4">
                                <div class="d-inline-block">
                                  <label>{{$lang.messages.id_card}}</label>
                                  <span style="color:#ff0000">*</span>
                                </div>
                                <div>
                                  <div class="mb-1">
                                    <a
                                      href="javascript:void(0)"
                                      data-toggle="modal"
                                      data-target="#openImg"
                                    >
                                      <img
                                        :src="client.person_info.id_card ? client.person_info.id_card: '/images/image-placeholder.jpg'"
                                        class="img-fluid w-50"
                                        alt="image thumb"
                                        id="id_card"
                                        width="180"
                                      />
                                    </a>
                                  </div>
                                  <button
                                    type="button"
                                    :disabled="!access_right.edit_account_information"
                                    class="btn px-3 upload-img-merge-btn rounded-8 btn-outline-primary w-50 text-capitalize"
                                  >
                                    {{$lang.messages.upload_image}}
                                    <input
                                      :disabled="!access_right.edit_account_information"
                                      type="file"
                                      class="btn upload-img"
                                      id="AddPhoto"
                                      accept="image/*"
                                      @change="onIdCardChange($event)"
                                    />
                                  </button>
                                </div>
                              </div>
                              <div class="col-lg-6 mb-4">
                                <div class="d-inline-block">
                                  <label>{{$lang.messages.selfie_with_id_card}}</label>
                                  <span style="color:#ff0000">*</span>
                                </div>
                                <div class>
                                  <div class="mb-1">
                                    <a
                                      href="javascript:void(0)"
                                      data-toggle="modal"
                                      data-target="#img"
                                    >
                                      <img
                                        :src="client.person_info.id_card_with_photo ? client.person_info.id_card_with_photo: '/images/image-placeholder.jpg'"
                                        class="img-fluid w-50"
                                        alt="image thumb"
                                        id="id_card_with_photo"
                                        width="180"
                                      />
                                    </a>
                                  </div>
                                  <button
                                    type="button"
                                    :disabled="!access_right.edit_account_information"
                                    class="btn px-3 upload-img-merge-btn rounded-8 btn-outline-primary w-50 text-capitalize"
                                  >
                                    {{$lang.messages.upload_image}}
                                    <input
                                      :disabled="!access_right.edit_account_information"
                                      type="file"
                                      accept="image/*"
                                      class="btn upload-img"
                                      id="AddPhoto"
                                      @change="onIdCardPhotoChange($event)"
                                    />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <h1 style="margin-top:30px;">{{$lang.messages.bank_information}}</h1>
                          <hr />
                          <div class="col-md-12">
                            <div class="row mb-4">
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.bank_name}}</label>
                                <div class="custom-select-dd">
                                  <select
                                    class="form-control"
                                    v-model="client.bank_info.bank_id"
                                    :disabled="!access_right.edit_account_information"
                                    name="bank_id"
                                  >
                                    <option value>{{$lang.messages.select}}</option>
                                    <option
                                      v-for="bank in bankList"
                                      :key="bank.name"
                                      :value="bank.id"
                                    >{{bank.name}}</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.account_holder_name}}</label>
                                <input
                                  name="user_name"
                                  v-model="client.bank_info.name"
                                  :disabled="!access_right.edit_account_information"
                                  class="form-control"
                                  type="text"
                                  placeholder="Name"
                                />
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for>{{$lang.messages.account_number}}</label>
                                  <input
                                    name="account_number"
                                    v-model="client.bank_info.account_number"
                                    :disabled="!access_right.edit_account_information"
                                    class="form-control"
                                    type="text"
                                    v-validate="'numeric'"
                                    :placeholder="$lang.messages.account_number"
                                    :class="{'input':true, 'is-danger': errors.has('business_form.account_number') }"
                                  />
                                  <i
                                    v-show="errors.has('business_form.account_number')"
                                    class="fa fa-warning"
                                  ></i>
                                  <span
                                    v-show="errors.has('business_form.account_number')"
                                    class="help is-danger"
                                  >Please enter valid account number</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <h1 style="margin-top:30px;">{{$lang.messages.country_language_chosen}}</h1>
                          <hr />
                          <div class="col-md-12">
                            <div class="row mb-4">
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.country}}</label>
                                <span style="color:#ff0000">*</span>
                                <div class="text-right custom-select-dd">
                                  <select
                                    v-model="client.business_info.country_id"
                                    :disabled="!access_right.edit_account_information"
                                    name="country_id"
                                    class="form-control"
                                    v-validate="'required'"
                                    :class="{'input':true, 'is-danger': errors.has('business_form.country_id') }"
                                    @change="getdata(client.business_info.country_id)"
                                  >
                                    <option value>{{$lang.messages.select_country}}</option>
                                    <option
                                      v-for="country in countryList"
                                      :key="country.id"
                                      :value="country.id"
                                    >{{country.name}}</option>
                                  </select>
                                  <i
                                    v-show="errors.has('business_form.country_id')"
                                    class="fa fa-warning"
                                  ></i>
                                  <span
                                    v-show="errors.has('business_form.country_id')"
                                    class="help is-danger"
                                  >{{$lang.messages.please_select_country}}</span>
                                </div>
                              </div>
                              <div class="col-lg-6 mb-4">
                                <label>{{$lang.messages.language}}</label>
                                <span style="color:#ff0000">*</span>
                                <div class="text-right custom-select-dd">
                                  <select
                                    v-model="client.business_info.ui_language"
                                    :disabled="!access_right.edit_account_information"
                                    name="ui_language"
                                    class="form-control"
                                    v-validate="'required'"
                                    :class="{'input':true, 'is-danger': errors.has('business_form.ui_language') }"
                                    @change="getBusinessType(true)"
                                  >
                                    <option value>Select Language</option>
                                    <option
                                      v-for="language in languageList"
                                      :key="language.id"
                                      :value="language.id"
                                    >{{language.name}}</option>
                                  </select>
                                  <i
                                    v-show="errors.has('business_form.ui_language')"
                                    class="fa fa-warning"
                                  ></i>
                                  <span
                                    v-show="errors.has('business_form.ui_language')"
                                    class="help is-danger"
                                  >Please select Language</span>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for>{{$lang.messages.timezone}}</label>
                                  <span style="color:#ff0000">*</span>
                                  <div class="custom-select-dd">
                                    <select
                                      class="form-control"
                                      v-model="client.business_info.timezone"
                                      :disabled="!access_right.edit_account_information"
                                      v-validate="'required'"
                                      name="timezone"
                                      :class="{'input':true, 'is-danger': errors.has('business_form.timezone') }"
                                    >
                                      <option value>{{$lang.messages.select}}</option>
                                      <option
                                        v-for="timezone in timezones"
                                        :key="timezone.name"
                                        :value="timezone.id"
                                      >{{timezone.name}} ({{timezone.value}})</option>
                                    </select>
                                    <i
                                      v-show="errors.has('business_form.timezone')"
                                      class="fa fa-warning"
                                    ></i>
                                    <span
                                      v-show="errors.has('business_form.timezone')"
                                      class="help is-danger"
                                    >{{$lang.messages.please_select_timezone}}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12 text-lg-right text-center">
                            <button
                              type="button"
                              class="btn btn-primary mr-3"
                              @click="validateBusinessForm()"
                            >{{$lang.messages.save_btn_text}}</button>
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              id="cancel1-btn"
                              @click="getGeneralSetting"
                            >{{$lang.messages.cancel_btn_text}}</button>
                          </div>
                        </form>
                      </div>

                      <div class="tab-pane fade form-style"
                        id="tab3"
                        role="tabpanel"
                        aria-labelledby="nav-tab8">
                        <div class="row mb-2">
                          <div class="col-12 text-right">
                            <button
                              @click="clearAddPaymentTypeModal($lang.messages.add, $event)"
                              data-toggle="modal"
                              data-target="#AddPaymentType"
                              class="btn btn-primary mr-lg-3 mb-lg-0 mb-2"
                            >+ {{$lang.messages.add_payment_type}}</button>
                            <div class="text-right custom-select-dd d-inline-block w-xs-100"
                              style="width: 180px;">
                              <select class="form-control"
                                v-model="payment_store_id"
                                @change="getPayments()">
                                <option value>{{$lang.messages.all_stores}}</option>
                                <option
                                  v-for="store in all_stores"
                                  :key="store.id"
                                  :value="store.id"
                                >{{store.name}}</option>
                              </select>
                            </div>
                          </div>

                          <div class="col-12">
                            <hr />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <div v-if="payments != null && payments.length > 0">
                              <div v-for="item in payments" :key="item.id">
                                <h3 class="mb-0 font-20 f-semi-bold">{{item.store_name}}</h3>
                                <div class="table-responsive">
                                <table class="table table-striped table-style-1 mb-4">
                                  <thead class="bg-light">
                                    <tr>
                                      <th scope="col">Sr.no</th>
                                      <th scope="col">{{$lang.messages.name}}</th>
                                      <th scope="col">{{$lang.messages.type}}</th>
                                      <th scope="col">{{$lang.messages.active}}</th>
                                      <th scope="col" class="text-right"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(option,i) in item.payments" :key="option.id">
                                      <td>{{i +1}}</td>
                                      <td> <span> <img :src="option.logo" height="20"> </span> {{option.name}}</td>
                                      <td>{{option.payment_type}}</td>
                                      <td>
                                        <div class="custom-control custom-checkbox">
                                          <input
                                            v-if="option.active === 0 || $_.filter($_.filter(payments, { store_id: item.store_id })[0].payments, function(o) {return o.active === 1 && o.payment_type != 'CASH' && o.payment_type != 'TUNAI' }).length > 1"
                                            type="checkbox"
                                            class="custom-control-input"
                                            :id="'avl_'+option.id"
                                            :value="option.active"
                                            v-model="option.active"
                                            :disabled="['TUNAI', 'CASH'].includes(option.payment_type.toUpperCase())"
                                            @change="checkUncheckPayment($event, option.id, item.store_id)"
                                          />
                                          <input
                                            v-else
                                            type="checkbox"
                                            class="custom-control-input"
                                            :id="'avl_'+option.id"
                                            :checked="option.active"
                                            :disabled="['TUNAI', 'CASH'].includes(option.payment_type.toUpperCase())"
                                            @click.stop="confirmCheckUncheckPayment($event, option.id, item.store_id, option.active)"
                                          />
                                          <label
                                            class="custom-control-label text-dark ml-2"
                                            :for="'avl_'+option.id"
                                          ></label>
                                        </div>
                                      </td>

                                      <td class="text-right">
                                        <a href="javascript:void(0)" v-if="!option.is_ralali_payment && (!!access_right.set_payment_type && !['TUNAI', 'CASH'].includes(option.payment_type.toUpperCase()))"
                                            @click="gotoPaymentEdit(option.payment_id)"
                                          class="text-primary mr-2 font-18">
                                          <i  class="mdi mdi-pencil"></i>
                                        </a>

                                        <a href="javascript:void(0)" v-if="!option.is_ralali_payment && (!!access_right.set_payment_type && !['TUNAI', 'CASH'].includes(option.payment_type.toUpperCase()))"
                                           @click="setObj(option.payment_id, item.store_id)"
                                           data-toggle="modal"
                                          data-target="#delete-payment-type-modal"
                                          class="text-primary mr-2 font-18">
                                          <i class="far fa-trash-alt font-20 text-danger"></i >
                                        </a>

                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                </div>
                              </div>
                            </div>
                            <ErrorComponent
                              @retry="paymentRetry()"
                              ref="paymentErrorComonent"
                            />
                          </div>
                        </div>
                      </div>


                      <div
                        :class="access_right.edit_profile ? '' : 'active'"
                        class="tab-pane show form-style"
                        id="tab5"
                        role="tabpanel"
                        aria-labelledby="nav-tab5"
                      >
                        <h3 class="font-22 mb-4">{{$lang.messages.receipt_setting}}</h3>

                        <div class="row mb-lg-5 mb-4">
                          <div class="col-lg-3">
                            <div class="text-right custom-select-dd w-xs-100" style="width: 180px;">
                              <select
                                v-model="receipt_store_id"
                                @change="getReceiptDetails()"
                                class="form-control"
                              >
                                <option
                                  v-for="store in all_stores"
                                  :key="store.id"
                                  :value="store.id"
                                >{{store.name}}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="row mb-lg-5 mb-4">
                          <div class="col-lg-4 col-md-5 mb-lg-0 mb-3">
                            <label>{{$lang.messages.emailed_receipt}}</label>
                            <div class="mb-0" style="height: 248px;">
                              <div
                                style="height: 215px;display: flex;overflow: hidden !important;align-items: initial;"
                              >
                                <img
                                  v-if="receipt.emailed_receipt"
                                  :src="receipt.emailed_receipt"
                                  class="img-fluid w-75"
                                  id="img_hoder_1"
                                  width="100%"
                                />

                                <img
                                  v-else
                                  src="/images/image-placeholder.jpg"
                                  class="img-fluid w-75"
                                  id="img_hoder_2"
                                  width="100%"
                                />
                              </div>
                              <button
                                type="button"
                                class="btn px-3 upload-img-merge-btn rounded-0 btn-primary w-75 text-capitalize"
                                style="height: 35px"
                              >
                                {{$lang.messages.upload}}
                                <input
                                  type="file"
                                  class="btn upload-img"
                                  id="emailReceiptPhoto"
                                  @change="onChange($event, 'EMAIL_RECEIPT')"
                                />
                              </button>
                            </div>
                            <!-- <div class="mb-0" v-else>
                              <img
                                src="images/image-placeholder.jpg"
                                class="img-fluid w-75"
                                id="img_hoder_1"
                                width="220"
                              />
                            </div>-->
                          </div>
                          <div class="col-lg-4 col-md-5">
                            <label>{{$lang.messages.printed_receipt}}</label>
                            <div class="mb-0" style="height: 248px;">
                              <div
                                style="height: 215px;display: flex;overflow: hidden !important;align-items: initial;"
                              >
                                <img
                                  v-if="receipt.printed_receipt"
                                  :src="receipt.printed_receipt"
                                  class="img-fluid w-75"
                                  id="img_hoder_2"
                                  width="100%"
                                />

                                <img
                                  v-else
                                  src="/images/image-placeholder.jpg"
                                  class="img-fluid w-75"
                                  id="img_hoder_1"
                                  width="220"
                                />
                              </div>

                              <button
                                type="button"
                                class="btn px-3 upload-img-merge-btn rounded-0 btn-primary w-75 text-capitalize"
                                style="height: 35px"
                              >
                                {{$lang.messages.upload}}
                                <input
                                  type="file"
                                  class="btn upload-img"
                                  id="printedReceiptPhoto"
                                  @change="onChange($event, 'PRINTED_RECEIPT')"
                                />
                              </button>
                            </div>
                          </div>
                        </div>

                        <form data-vv-scope="receipt-form">
                          <div class="row mb-lg-5 mb-4">
                            <div class="col-lg-12 mb-4">
                              <label for>{{$lang.messages.header}}</label>

                              <input
                                name="header"
                                v-model="receipt.header"
                                v-validate="'max:600'"
                                maxlength="600"
                                class="form-control"
                                :class="{'input':true, 'is-danger': errors.has('receipt-form.header') }"
                                type="text"
                                v-bind:placeholder="$lang.messages.header"
                              />
                              <i v-show="errors.has('receipt-form.header')" class="fa fa-warning"></i>
                              <span
                                v-show="errors.has('receipt-form.header')"
                                class="help is-danger"
                              >{{$lang.messages.please_enter_header}}</span>
                            </div>
                            <div class="col-lg-12">
                              <label for>{{$lang.messages.footer}}</label>
                              <input
                                name="footer"
                                v-model="receipt.footer"
                                v-validate="'max:600'"
                                maxlength="600"
                                class="form-control"
                                :class="{'input':true, 'is-danger': errors.has('receipt-form.footer') }"
                                type="text"
                                v-bind:placeholder="$lang.messages.footer"
                              />
                              <i v-show="errors.has('receipt-form.footer')" class="fa fa-warning"></i>
                              <span
                                v-show="errors.has('receipt-form.footer')"
                                class="help is-danger"
                              >{{$lang.messages.please_enter_footer}}</span>
                            </div>
                          </div>
                          <div class="row mb-3 mt-2">
                            <div class="col-lg-6 col-6">
                              <h3 class="font-22 mb-4">{{$lang.messages.show_customer_info}}</h3>
                            </div>
                            <div class="col-lg-6 col-6 text-right">
                              <div class="form-group">
                                <span class="switch switch-sm">
                                  <input
                                    type="checkbox"
                                    class="switch"
                                    id="switch-cus-info"
                                    v-model="receipt.show_customer_info"
                                  />
                                  <label for="switch-cus-info"></label>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div class="row mb-4">
                            <div class="col-lg-6 col-6">
                              <h3 class="font-22 mb-4">{{$lang.messages.show_comments}}</h3>
                            </div>
                            <div class="col-lg-6 col-6 text-right">
                              <div class="form-group">
                                <span class="switch switch-sm">
                                  <input
                                    type="checkbox"
                                    class="switch"
                                    id="switch-show-comments"
                                    v-model="receipt.show_comments"
                                  />
                                  <label for="switch-show-comments"></label>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div class="row mb-4">
                            <div class="col-lg-12">
                              <label for>{{$lang.messages.receipt_language}}</label>
                              <div class="custom-select-dd">
                                <select
                                  class="form-control"
                                  v-model="receipt.receipt_language"
                                  v-validate="'required'"
                                  name="receipt_language"
                                >
                                  <option value>{{$lang.messages.select}}</option>
                                  <option
                                    v-for="language in languages"
                                    :key="language.id"
                                    :value="language.id"
                                  >{{language.name}}</option>
                                </select>

                                <i
                                  v-show="errors.has('receipt-form.receipt_language')"
                                  class="fa fa-warning"
                                ></i>
                                <span
                                  v-show="errors.has('receipt-form.receipt_language')"
                                  class="help is-danger"
                                >{{$lang.messages.please_select_receipt_language}}</span>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-lg-12 text-lg-right text-center">
                              <button
                                id="receipt-save-btn"
                                type="button"
                                class="btn btn-primary mr-3"
                                @click="validateForm('receipt-form')"
                              >{{$lang.messages.save_btn_text}}</button>
                              <button
                                type="button"
                                class="btn btn-outline-primary"
                                @click="getReceiptDetails"
                              >{{$lang.messages.cancel_btn_text}}</button>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div
                        class="tab-pane fade form-style"
                        id="tab6"
                        role="tabpanel"
                        aria-labelledby="nav-tab6">
                        <div class="row mb-lg-5 mb-4 justify-content-end">
                          <div class="col-12 col-md-3">
                            <div class="text-right custom-select-dd">
                              <select
                                class="form-control"
                                v-model="open_tickets_store_id"
                                @change="getOpenTicketDetails()">
                                <option
                                  v-for="store in all_stores"
                                  :key="store.id"
                                  :value="store.id"
                                >{{store.name}}</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <form data-vv-scope="open-ticket-form" v-on:keydown.enter.prevent>
                          <div class="row mb-3 mt-2">
                            <div class="col-lg-6 col-6">
                              <h3 class="font-18 mb-0">{{$lang.messages.use_predefined_tickets}}</h3>
                              <p
                                class="font-14 text-grey"
                              >{{$lang.messages.use_predefined_tickets_text}}</p>
                            </div>
                            <div class="col-lg-6 col-6 text-right">
                              <div class="form-group">
                                <span class="switch switch-sm">
                                  <input
                                    type="checkbox"
                                    v-model="open_ticket.use_predefined_tickets"
                                    id="PredefinedTickets"
                                    class="switch"
                                    @click="checkUncheckPredefinedTickets($event)"
                                  />
                                  <label for="PredefinedTickets"></label>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div v-if="open_ticket.use_predefined_tickets">
                            <draggable
                              tag="ul"
                              :list="open_ticket.list"
                              class="list-group"
                              handle=".handle"
                            >
                              <li
                                class="list-group-item"
                                v-for="(ticket, index) in open_ticket.list"
                                :key="ticket.index"
                              >
                                <div class="col-lg-12 col-12 d-flex align-items-center mb-3">
                                  <div class="font-20 mr-3" style="cursor: all-scroll">
                                    <i class="fa fa-align-justify handle"></i>
                                  </div>
                                  <div class="col-lg-9">
                                    <div class="form-group" style="margin-bottom: 0px !important;">
                                      <input
                                        :id="'ticket_name_'  +index"
                                        :name="'ticket_name_'  +index"
                                        v-model="ticket.name"
                                        v-validate="'required'"
                                        :class="{'input':true, 'draginput': true, 'form-control' : true,  'is-danger': errors.has('open-ticket-form.ticket_name_'  +index) }"
                                        type="text"
                                      />
                                      <i
                                        v-show="errors.has('open-ticket-form.ticket_name_'  +index)"
                                        class="fa fa-warning"
                                      ></i>
                                      <span
                                        v-show="errors.has('open-ticket-form.ticket_name_'  +index)"
                                        class="help is-danger"
                                      >{{$lang.messages.please_enter_unique_option_name}}</span>
                                    </div>
                                  </div>
                                  <div class="text-right">
                                    <i class="fa fa-times close" @click="deleteTicket(index)"></i>
                                  </div>
                                </div>
                              </li>
                            </draggable>
                          </div>
                          <div class="row mb-3 mt-2" v-if="open_ticket.use_predefined_tickets">
                            <div class="col-lg-12 col-12">
                              <a
                                href="javascript:void(0)"
                                class="text-primary"
                                @click="validateFilledValues('open-ticket-form')"
                              >
                                <i class="fas fa-plus-circle font-18 mr-2"></i>
                                {{$lang.messages.add_option}}
                              </a>
                            </div>
                          </div>
                          <div class="row mt-5">
                            <div class="col-lg-12 text-lg-right text-center">
                              <button
                                type="button"
                                class="btn btn-primary mr-3"
                                @click="validateForm('open-ticket-form')"
                              >{{$lang.messages.save_btn_text}}</button>
                              <button
                                type="button"
                                @click="getOpenTicketDetails()"
                                class="btn btn-outline-primary"
                              >{{$lang.messages.cancel_btn_text}}</button>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div
                        class="tab-pane fade form-style"
                        id="tab7"
                        role="tabpanel"
                        aria-labelledby="nav-tab7"
                      >
                        <div class="row">
                          <div class="col-lg-4 col-2 text-left">
                            <button
                              type="button"
                              v-if="checkedPrinters && checkedPrinters.length > 0"
                              @click="showDeleteKitchenPrinterAlert($event)"
                              class="btn btn-light font-18"
                            >
                              <i class="far fa-trash-alt font-16 text-seconadry"></i>
                            </button>
                          </div>
                          <div class="col-lg-8 col-10 text-right">
                            <a
                              href="javascript:void(0)"
                              @click="gotoAddKitchenPrinter()"
                              class="btn btn-primary mr-3"
                            >+ {{$lang.messages.add}}</a>
                          </div>
                        </div>
                        <div class="table-responsive">
                        <table class="table table-striped table-style-1">
                          <thead>
                            <tr>
                              <th scope="col" width="40">Sr.no</th>
                              <th scope="col" width="40">
                                <div class="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="del_kp"
                                    ref="del_kp"
                                    @change="checkAllKitchenPrinter($event)"
                                  />
                                  <label class="custom-control-label text-dark ml-2" for="del_kp"></label>
                                </div>
                              </th>
                              <th
                                scope="col"
                                class="sorting"
                                @click="kitchenPrinterSorting($event, 'name')"
                              >{{$lang.messages.name}}</th>

                              <th scope="col">{{$lang.messages.categories}}</th>
                              <th class="text-right pr-lg-4">{{$lang.messages.action}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item,i) in printers" :key="item.id">
                              <td>{{ i +1}}</td>
                              <td>
                                <div class="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    :value="item.id"
                                    :id="'printer_check_'  +item.id"
                                    v-model="checkedPrinters"
                                    @change="checkUncheckKitchenPrinter($event)"
                                  />
                                  <label
                                    class="custom-control-label text-dark ml-2"
                                    :for="'printer_check_' +item.id"
                                  ></label>
                                </div>
                              </td>

                              <td>{{item.name}}</td>
                              <td>{{item.categories_count}}</td>
                              <td class="text-right pr-lg-4">
                                <a
                                  @click="gotoKitchenPrinterEdit(item.id )"
                                  href="javascript:void(0)"
                                  class="text-primary mr-2 font-18"
                                >
                                  <i class="mdi mdi-pencil"></i>
                                </a>
                                <a
                                  href="javascript:void(0)"
                                  class="text-grey font-18"
                                  data-toggle="modal"
                                  data-target="#delete-kitchen-printer-modal"
                                  @click="setKitchenPrinterObj(item, $lang.messages.delete_kitchen_printer_message)"
                                >
                                  <i class="far fa-trash-alt font-18 text-danger"></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <ErrorComponent
                          @retry="kitchenPrinterRetry()"
                          ref="kitchenPrinterErrorComonent"
                        />
                        </div>
                      </div>

                      <div
                        class="tab-pane fade form-style"
                        id="tab8"
                        role="tabpanel"
                        aria-labelledby="nav-tab8"
                      >
                        <!-- <h3 class="font-22 mb-4">{{$lang.messages.dinning_option}}</h3> -->
                        <div class="row mb-2">
                          <div class="col-12 text-right">
                            <button
                              @click="gotoAddDinningOption"
                              class="btn btn-primary mr-lg-3 mb-lg-0 mb-2"
                            >+ {{$lang.messages.add_dinning_option}}</button>
                            <div
                              class="text-right custom-select-dd d-inline-block w-xs-100"
                              style="width: 180px;"
                            >
                              <select
                                class="form-control"
                                v-model="dinning_option_store_id"
                                @change="getDinningOptions()"
                              >
                                <option value>{{$lang.messages.all_stores}}</option>
                                <option
                                  v-for="store in all_stores"
                                  :key="store.id"
                                  :value="store.id"
                                >{{store.name}}</option>
                              </select>
                            </div>
                          </div>

                          <div class="col-12">
                            <hr />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <div v-if="dinningOptions != null && dinningOptions.length > 0">
                              <div v-for="item in dinningOptions" :key="item.id">
                                <h3 class="mb-0 font-20 f-semi-bold">{{item.store_name}}</h3>
                                <div class="table-responsive">
                                <table
                                  class="table table-striped table-style-1 mb-4"
                                >
                                  <thead class="bg-light">
                                    <tr>
                                      <th scope="col">Sr.no</th>
                                      <th scope="col">{{$lang.messages.name}}</th>
                                      <th scope="col">{{$lang.messages.available}}</th>
                                      <th scope="col" width="250">{{$lang.messages.default}}</th>
                                      <th scope="col" class="text-right"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(option,i) in item.dining_options" :key="option.id">
                                      <td>{{i +1}}</td>
                                      <td>{{option.name}}</td>
                                      <td>
                                        <div class="custom-control custom-checkbox">
                                          <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            :id="'avl_'+option.id"
                                            :value="option.is_checked"
                                            v-model="option.is_checked"
                                            @change="checkUncheckDinningOption($event, option.id)"
                                          />
                                          <label
                                            class="custom-control-label text-dark ml-2"
                                            :for="'avl_'+option.id"
                                          ></label>
                                        </div>
                                      </td>
                                      <td>
                                        <div class="custom-control custom-checkbox">
                                          <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            :id="'avl2_'+option.id"
                                            :value="option.is_default"
                                            v-model="option.is_default"
                                            :disabled="!option.is_checked"
                                            @change="checkUncheckDefaultDinningOption($event, option.id)"
                                          />
                                          <label
                                            class="custom-control-label text-dark ml-2"
                                            :for="'avl2_'+option.id"
                                          ></label>
                                        </div>
                                      </td>
                                      <td class="text-right">
                                        <a href="javascript:void(0)"
                                          @click="gotoDinningOptionEdit(option.dinning_option_id )"
                                          class="text-primary mr-2 font-18"
                                        >
                                          <i v-if="option.editable" class="mdi mdi-pencil"></i>
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                </div>
                              </div>
                            </div>
                            <ErrorComponent
                              @retry="dinningOptionRetry()"
                              ref="dinningOptionErrorComonent"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Store Tab -->
                <div class="tab-pane fade" id="stores" role="tabpanel" aria-labelledby="stores-tab">
                  <div
                    class="tab-pane fade show active"
                    id="stores-contetn"
                    role="tabpanel"
                    aria-labelledby="stores-tab"
                  >
                    <div class="report-tab settings-inner-tab">
                      <nav class="mb-4 mt-3" v-show="!mobileSetting">
                        <div class="nav nav-tabs" id="nav-tab2" role="tablist">
                          <a
                            class="nav-item nav-link active text-center"
                            id="nav-tab1-1"
                            data-toggle="tab"
                            href="#tab1-1"
                            role="tab"
                            aria-controls="tab1-1"
                            aria-selected="true"
                            v-if="access_right.manage_stores"
                            @click="clickStoreAndPosSettingTab('STORE')"
                          >
                            <span class="tab-sub d-block">{{$lang.messages.stores}}</span>
                          </a>
                          <a
                            class="nav-item nav-link"
                            id="nav-tab2-link"
                            data-toggle="tab"
                            href="#tab2-2"
                            role="tab"
                            aria-controls="tab2-2"
                            aria-selected="false"
                            @click="clickStoreAndPosSettingTab('POS')"
                          >
                            <span class="tab-sub d-block">{{$lang.messages.pos_devices}}</span>
                          </a>
                          <a
                            v-if="setting.is_menu_app"
                            class="nav-item nav-link"
                            id="nav-tab3-link"
                            data-toggle="tab"
                            href="#tab3-3"
                            role="tab"
                            aria-controls="tab3-3"
                            aria-selected="false"
                            @click="clickStoreAndPosSettingTab('Menu')"
                          >
                            <span class="tab-sub d-block">{{$lang.messages.menu_devices}}</span>
                          </a>

                          <a
                            class="nav-item nav-link"
                            id="nav-tab4-link"
                            data-toggle="tab"
                            href="#tab4-4"
                            role="tab"
                            aria-controls="tab4-4"
                            aria-selected="false"
                            v-if="setting.storefront && access_right.bo_manage_online_storefront"
                            @click="clickStoreAndPosSettingTab('STOREFRONT')">
                            <span class="tab-sub d-block text-nowrap">{{ $lang.messages.online_storefront }}</span>
                          </a>


                          <a
                            class="nav-item nav-link"
                            id="nav-tab5-link"
                            data-toggle="tab"
                            href="#tab4-4"
                            role="tab"
                            aria-controls="tab4-4"
                            aria-selected="false"
                            v-if="d2c_type === 1"
                            @click="clickStoreAndPosSettingTab('SOBAT_CATEGORY')">
                            <span class="tab-sub d-block text-nowrap">Sobat category</span>
                          </a>

                        </div>
                      </nav>

                      <div class="tab-content px-3 pb-4 form-style" id="nav-tabContent2">
                        <div
                          class="tab-pane fade show active form-style"
                          id="tab1-1"
                          role="tabpanel"
                          aria-labelledby="nav-tab1-1"
                          v-show="!mobileSetting"
                          v-if="access_right.manage_stores">
                          <button
                            @click="gotoAddstore"
                            class="btn btn-primary mr-2 mb-4 float-right">+ {{$lang.messages.add_store}}</button>
                          <div class="table-responsive">
                            <table class="table table-striped table-style-1">
                              <thead>
                                <tr>
                                  <th scope="col">Sr.no</th>
                                  <th
                                    class="sorting"
                                    scope="col"
                                    @click="storeSorting($event, 'name')"
                                  >{{$lang.messages.name}}</th>
                                  <th
                                    scope="col"
                                    class="sorting"
                                    @click="storeSorting($event, 'address')"
                                  >{{$lang.messages.address}}</th>
                                  <th
                                    scope="col"
                                    class="sorting"
                                    @click="storeSorting($event, 'status')"
                                  >{{$lang.messages.status}}</th>
                                  <th scope="col" class="text-center">{{$lang.messages.number_of_pos}}</th>
                                  <th scope="col" class="text-center">{{$lang.messages.action}}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(store,i) in stores" :key="store.id">
                                  <td>{{ i +1}}</td>
                                  <td>{{store.name}}</td>
                                  <td>{{store.address}}</td>
                                  <td>{{store.status}}</td>
                                  <td class="text-center">{{store.number_of_pos}}</td>
                                  <td class="text-center">
                                    <a
                                      href="javascript:void(0)"
                                      @click="gotoStoreEdit(store.id)"
                                      class="text-primary mr-2 font-18"
                                    >
                                      <i class="mdi mdi-pencil font-20"></i>
                                    </a>
                                    &nbsp;&nbsp;
                                    <a
                                      href="javascript:void(0)"
                                      data-toggle="modal"
                                      data-target="#delete-store-modal"
                                      @click="setStoreObj(store, $lang.messages.confirm_delete_store_message)"
                                      class="text-grey font-18"
                                    >
                                      <i class="far fa-trash-alt font-20 text-danger"></i>
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <ErrorComponent @retry="storeRetry()" ref="storeErrorComonent" />
                          </div>
                        </div>

                        <div
                          class="tab-pane fade"
                          id="tab2-2"
                          role="tabpanel"
                          aria-labelledby="nav-tab2"
                           v-show="!mobileSetting">
                          <div class="mb-3 text-md-right text-center">
                            <div
                              class="text-right custom-select-dd d-inline-block mr-lg-3 mr-md-1 mb-lg-0 mb-3 w-xs-100"
                              style="width: 160px;">
                              <select
                                v-model="store_id"
                                @change="getPOSList()"
                                class="form-control">
                                <option value>{{$lang.messages.all_stores}}</option>
                                <option
                                  v-for="store in all_stores"
                                  :key="store.id"
                                  :value="store.id"
                                >{{store.name}}</option>
                              </select>
                            </div>

                            <button
                              @click="gotoAddPOS"
                              class="btn btn-primary mr-2 mb-4 float-right">+ {{$lang.messages.add_pos}}</button>
                          </div>

                          <div class="table-responsive">
                            <table class="table table-striped table-style-1">
                              <thead>
                                <tr>
                                  <th scope="col">Sr.no</th>
                                  <th
                                    scope="col"
                                    class="sorting"
                                    @click="posSorting($event, 'name')"
                                  >{{$lang.messages.name}}</th>
                                  <th
                                    scope="col"
                                    class="sorting"
                                    @click="posSorting($event, 'store_name')"
                                  >{{$lang.messages.store}}</th>
                                  <th
                                    scope="col"
                                    class="sorting"
                                    @click="posSorting($event, 'pos_status')"
                                  >{{$lang.messages.status}}</th>
                                  <th scope="col">{{$lang.messages.deactivate}}</th>
                                  <th scope="col" class="text-center">{{$lang.messages.action}}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(pos,i) in pos_list" :key="pos.id">
                                  <td>{{ i +1}}</td>
                                  <td>{{pos.name}}</td>
                                  <td>{{pos.store_name}}</td>
                                  <td
                                    class="text-success"
                                    v-if="pos.pos_status != null && (pos.pos_status == 'ACTIVATED')"
                                  >{{$lang.messages.activated}}</td>
                                  <td v-else class="text-danger">{{$lang.messages.not_activated}}</td>
                                  <td v-if="pos.pos_status == 'ACTIVATED' ">
                                    <button
                                      type="button"
                                      class="btn btn-primary mr-3"
                                      data-toggle="modal"
                                      data-target="#release-pos-modal"
                                      @click="releasePOSObj(pos, $lang.messages.confirm_release_pos_message)"
                                    >{{$lang.messages.deactivate}}</button>
                                  </td>
                                  <td v-else></td>
                                  <td class="text-center">
                                    <a
                                      href="javascript:void(0)"
                                      @click="gotoPOSEdit(pos.id)"
                                      class="text-primary mr-2 font-18"
                                    >
                                      <i class="mdi mdi-pencil font-20"></i>
                                    </a>
                                    &nbsp;&nbsp;
                                    <a
                                      href="javascript:void(0)"
                                      data-toggle="modal"
                                      data-target="#delete-pos-modal"
                                      @click="setPOSObj(pos, $lang.messages.confirm_delete_pos_message)"
                                      class="text-grey font-18"
                                    >
                                      <i class="far fa-trash-alt font-20 text-danger"></i>
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <ErrorComponent @retry="posRetry()" ref="posErrorComonent" />
                          </div>
                        </div>

                        <div
                          class="tab-pane fade"
                          id="tab3-3"
                          role="tabpanel"
                          aria-labelledby="nav-tab3"
                           v-show="!mobileSetting"
                        >
                          <div class="mb-3 text-md-right text-center">
                            <div
                              class="text-right custom-select-dd d-inline-block mr-lg-3 mr-md-1 mb-lg-0 mb-3 w-xs-100"
                              style="width: 160px;"
                            >
                              <select
                                v-model="store_id"
                                @change="getMenuList()"
                                class="form-control"
                              >
                                <option value>{{$lang.messages.all_stores}}</option>
                                <option
                                  v-for="store in all_stores"
                                  :key="store.id"
                                  :value="store.id"
                                >{{store.name}}</option>
                              </select>
                            </div>

                            <a
                              href="javascript:void(0)"
                              @click="gotoAddMenu"
                              class="btn btn-primary mr-2 mb-4 float-right"
                            >+ {{$lang.messages.add_menu}}</a>
                          </div>

                          <div class="table-responsive">
                            <table class="table table-striped table-style-1">
                              <thead>
                                <tr>
                                  <th scope="col" width="40">Sr.no</th>
                                  <th
                                    scope="col"
                                    class="sorting"
                                    @click="menuSorting($event, 'name')"
                                  >{{$lang.messages.name}}</th>
                                  <th
                                    scope="col"
                                    class="sorting"
                                    @click="menuSorting($event, 'store_name')"
                                  >{{$lang.messages.store}}</th>
                                  <th
                                    scope="col"
                                    class="sorting"
                                    @click="menuSorting($event, 'menu_status')"
                                  >{{$lang.messages.status}}</th>
                                  <th scope="col" class="text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(menu,i) in menu_list" :key="menu.id">
                                  <td>{{i +1}}</td>
                                  <td>{{menu.name}}</td>
                                  <td>{{menu.store_name}}</td>
                                  <td
                                    class="text-success"
                                    v-if="menu.menu_status != null && (menu.menu_status == 'ACTIVATED')"
                                  >{{$lang.messages.activated}}</td>
                                  <td v-else class="text-danger">{{$lang.messages.not_activated}}</td>
                                  <td class="text-center">
                                    <a
                                      href="javascript:void(0)"
                                      @click="gotoMenuEdit(menu.id)"
                                      class="text-primary mr-2 font-18"
                                    >
                                      <i class="mdi mdi-pencil font-20"></i>
                                    </a>
                                    &nbsp;&nbsp;
                                    <a
                                      href="javascript:void(0)"
                                      data-toggle="modal"
                                      data-target="#delete-menu-modal"
                                      @click="setMenuObj(menu, $lang.messages.confirm_delete_menu_message)"
                                      class="text-grey font-18"
                                    >
                                      <i class="far fa-trash-alt font-20 text-danger"></i>
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <ErrorComponent @retry="menuRetry()" ref="menuErrorComonent" />
                          </div>
                        </div>

                        <div
                          class="tab-pane fade"
                          id="tab4-4"
                          role="tabpanel"
                          aria-labelledby="nav-tab4">
                          <OnlineStorefront
                              @goToPayment="selectMainTab('PAYMENT_TYPE')"
                              @needConfirm="settingOnlineStorefrontNeedConfirm = $event"
                              v-if="settingOnlineStorefront"
                              :mobile-setting="mobileSetting" />
                          <SobatCategory
                              v-if="settingSobatCategory"
                              :mobile-setting="mobileSetting" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-10 text-right"></div>
        </div>
      </div>
    </div>
    <Alert
      @rightButtonEvent="addSubscription($event)"
      title="Subscription"
      ref="subscrideSubscriptionAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-multiple-employee-modal"
    />

    <a
      data-toggle="modal"
      data-target="#delete-multiple-employee-modal"
      ref="subscrideSubscriptionLink"
      style="display: none"
    />

    <Alert
      @rightButtonEvent="unSubscription($event)"
      title="Subscription"
      ref="unsubscrideSubscriptionAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-unsubscride-modal"
    />

    <Alert
      @rightButtonEvent="forceSaveStorefront($event)"
      v-bind:title="$lang.messages.online_storefront"
      ref="forceSaveStorefront"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="force-save-storefront-modal"
    />

    <Alert
      @rightButtonEvent="forceDisableDeliveryOption($event)"
      v-bind:title="$lang.messages.online_storefront"
      ref="forceDisableDeliveryOption"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="force-disable-delivery-option"
    />

    <Alert
      @rightButtonEvent="forceSaveDiningOption($event)"
      v-bind:title="$lang.messages.dinning_options"
      ref="forceSaveDiningOption"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="force-save-dining-options-modal"
    />

    <a
      data-toggle="modal"
      data-target="#delete-unsubscride-modal"
      ref="unsubscrideSubscriptionLink"
      style="display: none"
    />
    <Alert
      @rightButtonEvent="deletePOS($event)"
      ref="deletePOSAlert"
      v-bind:title="$lang.messages.delete_pos"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-pos-modal"
    />

    <Alert
      @rightButtonEvent="releasePOS($event)"
      ref="releasePOSAlert"
      v-bind:title="$lang.messages.release_pos"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="release-pos-modal"
    />

    <Alert
      @rightButtonEvent="deleteMenu($event)"
      ref="deleteMenuAlert"
      v-bind:title="$lang.messages.delete_menu"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-menu-modal"
    />

    <Alert
      @rightButtonEvent="deleteStore($event)"
      ref="deleteStoreAlert"
      v-bind:title="$lang.messages.delete_store"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-store-modal"
    />

    <Alert
      @rightButtonEvent="deletePaymentType($event)"
      v-bind:title="$lang.messages.delete_payment_type"
      ref="deletePaymentTypeAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-payment-type-modal"
    />

    <Alert
      @rightButtonEvent="doConfirmcheckUncheckPayment($event)"
      v-bind:title="''"
      ref="confirmUncheckPayment"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="uncheck-payment-type-modal"
    />

    <Alert
      @rightButtonEvent="deleteKitchenPrinter(false)"
      @leftButtonEvent="unselectAllKitchenPrinter()"
      v-bind:title="$lang.messages.delete_kitchen_printer"
      ref="deleteKitchenPrinterAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-kitchen-printer-modal"
    />

    <Alert
      @rightButtonEvent="deleteKitchenPrinter(true)"
      v-bind:title="$lang.messages.delete_kitchen_printer"
      ref="deleteMultipleKitchenPrinterAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-multiple-kitchen-printer-modal"
    />

    <a
      data-toggle="modal"
      data-target="#delete-multiple-kitchen-printer-modal"
      ref="deleteMulitpleKitchenPrinterLink"
      style="display: none"
    />

    <a
      data-toggle="modal"
      data-target="#delete-multiple-payment-type-modal"
      ref="deleteMultiplePaymentTypeLink"
      style="display: none"
    />

    <a
      data-toggle="modal"
      data-target="#delete-multiple-taxes-modal"
      ref="deleteMultipleTaxesLink"
      style="display: none"
    />

    <!-- Modal Box Add Payment Type-->
    <div
      class="modal fade"
      id="AddPaymentType"
      tabindex="-1"
      role="dialog"
      aria-labelledby="AddPaymentType"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content px-lg-4 py-lg-4">
          <div class="modal-header border-0">
            <h5 class="modal-title font-22">{{paymentTypeOperation}} {{$lang.messages.payment_type}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form data-vv-scope="add-payment-type-form">
            <div class="modal-body form-style">
              <div class="row mb-4">
                <div class="col-lg-12 mb-4">
                  <label for>{{$lang.messages.type}}</label>
                  <span style="color:#ff0000">*</span>
                  <div class="custom-select-dd">
                    <select
                      class="form-control"
                      v-model="payment_type.payment_type"
                      v-validate="'required'"
                      name="payment_type"
                    >
                      <option value>{{$lang.messages.select}}</option>
                      <option value="BANK_TRANSFER">BANK_TRANSFER</option>
                      <option value="VIRTUAL_ACCOUNT">VIRTUAL_ACCOUNT</option>
                      <option value="DIGITAL_WALLET">DIGITAL_WALLET</option>
                      <option value="CARD">{{$lang.messages.card}}</option>
                      <option value="E-WALLET">{{$lang.messages.e_wallet}}</option>
                      <option value="OTHER">{{$lang.messages.other}}</option>
                    </select>

                    <i
                      v-show="errors.has('add-payment-type-form.payment_type')"
                      class="fa fa-warning"
                    ></i>
                    <span
                      v-show="errors.has('add-payment-type-form.payment_type')"
                      class="help is-danger"
                    >{{$lang.messages.please_select_payment_type}}</span>
                  </div>
                </div>

                <template v-if="payment_type.payment_type == 'E-WALLET'">
                  <div class="col-lg-12 mb-4">
                    <label for>{{$lang.messages.name}}</label>
                    <span style="color:#ff0000">*</span>
                    <div class="custom-select-dd">
                      <multiselect v-model="e_wallet_payment" :placeholder="$lang.messages.name" label="name" track-by="id" :options="e_wallet_payment_name_list" :option-height="104" :show-labels="false">
                        <template slot="singleLabel" slot-scope="props">
                          <img height="30px" class="option__image" :src="props.option.logo">
                          <span class="option__desc" style="margin-left: 10px">
                          <span class="option__title">{{ props.option.name }}</span></span>
                        </template>

                        <template slot="option" slot-scope="props">
                          <div class="option__desc" style="display: flex; align-items: center">
                            <div v-if="!!props.option.logo" style="width: 120px">
                              <img height="30px" class="option__image" :src="props.option.logo" style="margin: 0 auto; display: flex">
                            </div>
                            <span class="option__small">{{ props.option.name }}</span>
                          </div>
                        </template>
                      </multiselect>

                      <i
                        v-show="errors.has('add-payment-type-form.payment_name')"
                        class="fa fa-warning"
                      ></i>
                      <span
                        v-show="errors.has('add-payment-type-form.payment_name')"
                        class="help is-danger"
                      >{{$lang.messages.please_select_payment_name}}</span>
                    </div>
                  </div>

                  <div
                    v-if="e_wallet_payment && (['OTHER', 'LAINNYA'].includes(e_wallet_payment.name.toUpperCase()))"
                    class="col-lg-12 mb-4">
                    <label for>{{ $lang.messages.payment_name }}</label>
                    <span style="color:#ff0000">*</span>
                    <input
                      name="e-wallet-other-name"
                      v-model="e_wallet_other_payment_name"
                      v-validate="'required|max:300'"
                      maxlength="300"
                      class="form-control"
                      :class="{'input':true, 'is-danger': errors.has('add-payment-type-form.e-wallet-other-name') }"
                      type="text"
                      v-bind:placeholder="$lang.messages.payment_name"
                    />
                    <i
                      v-show="errors.has('add-payment-type-form.e-wallet-other-name')"
                      class="fa fa-warning"
                    ></i>
                    <span
                      v-show="errors.has('add-payment-type-form.e-wallet-other-name')"
                      class="help is-danger"
                    >{{$lang.messages.please_enter_valid_name}}</span>
                  </div>
                </template>

                <div class="col-lg-12 mb-4" v-else>
                  <label for>{{$lang.messages.name}}</label>
                  <span style="color:#ff0000">*</span>
                  <input
                    name="payment-name"
                    v-model="payment_type.name"
                    v-validate="'required|max:300'"
                    maxlength="300"
                    class="form-control"
                    :class="{'input':true, 'is-danger': errors.has('add-payment-type-form.payment-name') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.name"
                  />
                  <i
                    v-show="errors.has('add-payment-type-form.payment-name')"
                    class="fa fa-warning"
                  ></i>
                  <span
                    v-show="errors.has('add-payment-type-form.payment-name')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_valid_name}}</span>
                </div>

                <div class="col-lg-12 mb-4" v-if="payment_type.payment_type == 'E-WALLET' ">
                  <label for>{{$lang.messages.e_wallet_mobile_phone_number}}</label>
                  <span style="color:#ff0000">*</span>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend"><label class="input-group-text">+62</label></div>
                    <input
                    name="payment-phone-number"
                    v-model="payment_type.phone_number"
                    v-validate="'required|numeric|min:7|notStartWithZero'"
                    maxlength="300"
                    class="form-control"
                    :class="{'input':true, 'is-danger': errors.has('add-payment-type-form.payment-phone-number') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.phone_number"
                    />
                  </div>
                  <i v-show="errors.has('add-payment-type-form.payment-phone-number')" class="fa fa-warning"></i>
                    <span v-show="errors.has('add-payment-type-form.payment-phone-number')"
                      class="help is-danger"
                    >{{$lang.messages.please_enter_mobile_number}}</span>
                </div>

                <div class="col-lg-12 mb-4">
                  <div class="card rounded-5 pt-1 border">
                    <div
                      class="card-header bg-white border-bottom cursor-pointer px-lg-5 px-4"
                      data-toggle="collapse"
                      data-target=".stores-list"
                      aria-expanded="true"
                      aria-controls="multiCollapseExample1 multiCollapseExample2"
                    >
                      <h4 class="font-20 d-inline">
                        {{$lang.messages.store}}
                        <span
                          class="font-16 ml-3 d-inline"
                        >{{availableStoreStr}}</span>
                      </h4>
                      <img src="/images/down-arrow.svg" width="15" class="d-inline float-right mt-1" />
                    </div>
                    <div class="card-body form-style collapse stores-list px-lg-5 px-4 show">

                      <form @submit.prevent="searchStores($event)" class="mb-3">
                        <div class="input-group input-group-lg">
                          <span class="input-group-append">
                            <button class="btn btn-outline-secondary" type="submit" style="height: 40px;border-color: #c5c5c5;">
                                <i class="fa fa-search"></i>
                            </button>
                          </span>
                          <input
                              type="text"
                              class="form-control input-lg"
                              v-model="query"
                              v-on:input="searchStores($event)"
                              :placeholder="$lang.messages.search_store"/>
                        </div>
                      </form>

                      <div class="custom-control custom-checkbox" v-if="query == ''">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="checkbox-1"
                          v-model="isAll"
                          @change="checkAllStores($event)"
                        />
                        <label
                          class="custom-control-label text-dark ml-2"
                          for="checkbox-1"
                        >{{$lang.messages.available_in_all_stores}}</label>
                      </div>
                      <div class="dropdown-divider" style="border-top: 1px solid #c3c3c3;" v-if="query == ''"></div>
                      <div>
                        <div
                          class="custom-control custom-checkbox mb-3"
                          v-for="store in storeList"
                          :key="store.id"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :value="store.id"
                            :id="'type_'  +store.id"
                            v-model="selectedStores"
                            @change="checkUncheckStore($event)"
                          />

                          <label
                            class="custom-control-label text-dark ml-2"
                            :for="'type_' +store.id"
                          >{{store.name}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="modal-footer border-0 justify-content-center">
              <button
                type="button"
                class="btn btn-primary mr-3"
                id="payment-type-save-btn"
                @click="validateForm('add-payment-type-form')"
              >{{$lang.messages.save_btn_text}}</button>
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-primary"
                id="payment-type-cancel-btn"
              >{{$lang.messages.cancel_btn_text}}</button>
            </div>
          </form>
        </div>
      </div>
    </div>


    <div
      class="modal fade"
      id="ChangePassword"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ChangePassword"
      ref="changePasswordForm"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content px-lg-4 py-lg-4">
          <div class="modal-header border-0">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <h5 class="modal-title font-22 text-center mb-2">{{ $lang.messages.set_new_signin_password }}</h5>
          <p>{{ $lang.messages.recommend_change_password }}</p>

          <form @submit.prevent="onUpdateEmployeePassword" class="form-style" data-vv-scope="employeeChangePasswordForm">
            <div class="form-group">
              <label>{{ $lang.messages.old_password }}</label>

              <div class="input-group show_hide_password">
                <input
                  name="old_password"
                  v-model="employeeChangePassword.old_password"
                  class="input form-control"
                  v-validate="'required'"
                  :class="{'input':true, 'is-danger': errors.has('employeeChangePasswordForm.old_password') }"
                  type="password"
                />
                <div class="input-group-addon border border-left-0 py-1 px-2 border-secondary bg-light">
                  <a href style="vertical-align: sub;">
                    <i class="fa fa-eye-slash" aria-hidden="true"></i>
                  </a>
                </div>
              </div>

              <i v-show="errors.has('employeeChangePasswordForm.old_password')" class="fa fa-warning"></i>
              <span
                v-show="errors.has('employeeChangePasswordForm.old_password')"
                class="help is-danger"
              >{{ $lang.messages.please_enter_old_password }}</span>
            </div>

            <div class="form-group">
              <label>{{ $lang.messages.new_password }}</label>
              <div class="input-group show_hide_password">
                <input
                  ref="employeePassword"
                  name="new_password"
                  v-model="employeeChangePassword.new_password"
                  class="input form-control"
                  v-validate="'required'"
                  :class="{'input':true, 'is-danger': errors.has('employeeChangePasswordForm.new_password') }"
                  type="password"
                />

                <div class="input-group-addon border border-left-0 py-1 px-2 border-secondary bg-light">
                  <a href style="vertical-align: sub;">
                    <i class="fa fa-eye-slash" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
              <i v-show="errors.has('employeeChangePasswordForm.new_password')" class="fa fa-warning"></i>
              <span
                v-show="errors.has('employeeChangePasswordForm.new_password')"
                class="help is-danger"
              >{{ $lang.messages.please_enter_new_password }}</span>
            </div>

            <div class="form-group">
              <label>{{ $lang.messages.confirm_password }}</label>
              <div class="input-group show_hide_password">
                <input
                  name="confirm_password"
                  v-model="employeeChangePassword.confirm_password"
                  class="input form-control"
                  v-validate="'required|confirmed:employeePassword'"
                  :class="{'input':true, 'is-danger': errors.has('employeeChangePasswordForm.confirm_password') }"
                  type="password"
                />

                <div class="input-group-addon border border-left-0 py-1 px-2 border-secondary bg-light">
                  <a href style="vertical-align: sub;">
                    <i class="fa fa-eye-slash" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
              <i v-show="errors.has('employeeChangePasswordForm.confirm_password')" class="fa fa-warning"></i>
              <span
                v-show="errors.has('employeeChangePasswordForm.confirm_password')"
                class="help is-danger"
              >{{ $lang.messages.please_enter_confirm_password }}</span>
            </div>

            <div class="form-group text-center">
              <button type="submit" class="btn btn-primary d-block" style="width: 100%">{{ $lang.messages.save }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <a data-toggle="modal" data-target="#ChangePassword" ref="ChangePasswordLink" style="display: block" />
  </div>
</template>
